// Dutch translations - Complete
export default {
  nav: {
    home: 'Home',
    dashboard: 'Dashboard',
    login: 'Inloggen',
    register: 'Registreren',
    logout: 'Uitloggen',
    settings: 'Instellingen',
    admin: 'Admin',
    menu: 'Menu',
    createQuiz: 'Quiz maken',
    createQuestionnaire: 'Vragenlijst maken',
    createEvent: 'Evenement maken',
    quizMusic: 'Quiz muziek',
    users: 'Gebruikers',
    backToDashboard: 'Terug naar dashboard'
  },
  common: {
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    create: 'Maken',
    add: 'Toevoegen',
    search: 'Zoeken',
    filter: 'Filteren',
    loading: 'Laden...',
    error: 'Fout',
    success: 'Succes',
    confirm: 'Bevestigen',
    confirmDelete: 'Verwijdering bevestigen',
    confirmDeleteMessage: 'Weet u zeker dat u wilt verwijderen',
    back: 'Terug',
    next: 'Volgende',
    previous: 'Vorige',
    close: 'Sluiten',
    yes: 'Ja',
    no: 'Nee',
    true: 'Waar',
    false: 'Onwaar',
    all: 'Alle',
    none: 'Geen',
    download: 'Downloaden',
    share: 'Delen',
    copy: 'Kopiëren',
    copied: 'Gekopieerd!',
    play: 'Spelen',
    view: 'Bekijken',
    actions: 'Acties',
    logoutSuccess: 'Succesvol uitgelogd',
    or: 'of',
    and: 'en',
    welcome: 'Welkom',
    required: 'Verplicht',
    optional: 'Optioneel',
    important: 'Belangrijk',
    submit: 'Verzenden',
    reset: 'Reset',
    start: 'Starten',
    stop: 'Stoppen',
    pause: 'Pauze',
    resume: 'Hervatten',
    finish: 'Voltooien',
    continue: 'Doorgaan',
    skip: 'Overslaan',
    retry: 'Opnieuw',
    refresh: 'Vernieuwen',
    more: 'Meer',
    less: 'Minder',
    show: 'Tonen',
    hide: 'Verbergen',
    enable: 'Inschakelen',
    disable: 'Uitschakelen',
    select: 'Selecteren',
    selected: 'Geselecteerd',
    upload: 'Uploaden',
    uploading: 'Uploaden...',
    preview: 'Voorbeeld',
    export: 'Exporteren',
    import: 'Importeren',
    print: 'Afdrukken',
    send: 'Verzenden',
    sending: 'Verzenden...',
    sent: 'Verzonden',
    noResults: 'Geen resultaten',
    loadMore: 'Meer laden',
    seeAll: 'Alles bekijken',
    duplicate: 'Dupliceren',
    saving: 'Opslaan...',
    saveChanges: 'Wijzigingen opslaan',
    copy: 'kopie',
    showMore: 'Meer tonen',
    showLess: 'Minder tonen',
    from: 'Van',
    to: 'Naar',
    date: 'Datum',
    time: 'Tijd',
    name: 'Naam',
    email: 'E-mail',
    phone: 'Telefoon',
    address: 'Adres',
    description: 'Beschrijving',
    title: 'Titel',
    status: 'Status',
    type: 'Type',
    category: 'Categorie',
    total: 'Totaal',
    quantity: 'Aantal',
    price: 'Prijs',
    free: 'Gratis',
    new: 'Nieuw',
    active: 'Actief',
    inactive: 'Inactief',
    pending: 'In behandeling',
    approved: 'Goedgekeurd',
    rejected: 'Afgewezen',
    public: 'Openbaar',
    private: 'Privé',
    draft: 'Concept',
    published: 'Gepubliceerd',
    admin: 'Admin',
    user: 'Gebruiker',
    madeWith: 'Gemaakt met',
    backToHome: 'Terug naar home',
    checking: 'Controleren...',
    verification: 'Verificatie',
    access: 'Toegang'
  },

  messages: {
    success: {
      saved: 'Succesvol opgeslagen',
      deleted: 'Succesvol verwijderd',
      updated: 'Succesvol bijgewerkt',
      created: 'Succesvol aangemaakt',
      copied: 'Gekopieerd!',
      linkCopied: 'Link gekopieerd!',
      emailSent: 'E-mail verzonden!',
      emailVerified: 'E-mail geverifieerd! Doorsturen...',
      emailAlreadyVerified: 'Uw e-mail is al geverifieerd!',
      verificationEmailSent: '📧 Verificatie-e-mail verzonden! Controleer ook uw spam-map.',
      tableCreated: 'Tafel succesvol aangemaakt',
      tableUpdated: 'Tafel succesvol bijgewerkt',
      tableDeleted: 'Tafel verwijderd',
      tableAdded: 'Tafel toegevoegd',
      guestAssigned: 'Gast toegewezen',
      guestRemoved: 'Gast verwijderd van tafel',
      planSaved: 'Plan opgeslagen',
      questionDuplicated: 'Vraag gedupliceerd',
      questionnaireUpdated: 'Vragenlijst bijgewerkt!',
      quizUpdated: 'Quiz bijgewerkt!',
      responseDeleted: 'Antwoord verwijderd',
      musicDeleted: 'Muziek verwijderd',
      accountCreatedResend: 'Account aangemaakt! Klik op "E-mail opnieuw verzenden" om de verificatielink te ontvangen.'
    },
    error: {
      generic: 'Er is een fout opgetreden',
      loading: 'Fout bij het laden',
      saving: 'Fout bij het opslaan',
      deleting: 'Fout bij het verwijderen',
      creating: 'Fout bij het aanmaken',
      updating: 'Fout bij het bijwerken',
      unauthorized: 'Ongeautoriseerde toegang',
      notFound: 'Item niet gevonden',
      quizNotFound: 'Quiz niet gevonden',
      questionnaireNotFound: 'Vragenlijst niet gevonden',
      eventNotFound: 'Evenement niet gevonden',
      sessionNotFound: 'Sessie niet gevonden',
      sessionStarted: 'Deze sessie is al gestart',
      accessDenied: 'U bent niet gemachtigd om deze pagina te openen',
      adminOnly: 'Alleen voor beheerders',
      logoutError: 'Fout bij het uitloggen',
      tooManyAttempts: 'Te veel pogingen. Probeer het over een paar minuten opnieuw.',
      sessionExpired: 'Sessie verlopen. Log opnieuw in.',
      emailNotVerified: 'E-mail nog niet geverifieerd. Controleer uw inbox en spam-map.',
      emailVerifiedNotValidated: 'E-mail geverifieerd maar account niet gevalideerd. Neem contact op met de beheerder.',
      qrCodeNotRecognized: 'QR-code niet herkend',
      qrCodeWrongEvent: 'Dit ticket hoort niet bij dit evenement',
      qrCodeReadError: 'Fout bij het lezen van QR-code',
      playbackError: 'Afspeelfout',
      assignmentError: 'Fout bij toewijzing'
    },
    validation: {
      required: 'Dit veld is verplicht',
      titleRequired: 'Titel is verplicht',
      nameRequired: 'Tafelnaam verplicht',
      tableNameRequired: 'Voer een tafelnaam in',
      sessionCodeRequired: 'Voer een sessiecode in',
      minQuestions: 'Voeg minstens één vraag toe',
      minOneQuestion: 'Minimaal 1 vraag vereist',
      questionTextRequired: 'Alle vragen moeten tekst hebben',
      minOptions: 'Minimaal 2 opties vereist',
      passwordMinLength: 'Wachtwoord moet minimaal 8 tekens zijn',
      passwordLowercase: 'Wachtwoord moet minimaal één kleine letter bevatten',
      passwordUppercase: 'Wachtwoord moet minimaal één hoofdletter bevatten',
      passwordSpecialChar: 'Wachtwoord moet minimaal één speciaal teken bevatten (bijv. #, @, !)'
    },
    confirm: {
      delete: 'Weet u zeker dat u dit item wilt verwijderen?',
      logout: 'Weet u zeker dat u wilt uitloggen?'
    }
  },

  pendingValidation: {
    title: 'Verifieer uw e-mail',
    emailSentTo: 'Een verificatie-e-mail is verzonden naar',
    checkInbox: '📧 Klik op de link in de e-mail om uw adres te verifiëren. Controleer ook uw spam-map.',
    accessGranted: '✅ Zodra uw e-mail is geverifieerd, heeft u direct toegang tot uw account!',
    iVerified: 'Ik heb mijn e-mail geverifieerd',
    resendEmail: 'Verificatie-e-mail opnieuw verzenden',
    logout: 'Uitloggen'
  },

  home: {
    title: 'Welkom bij HugoQuiz',
    subtitle: 'Maak quizzen, vragenlijsten en beheer uw evenementen',
    startFree: 'Gratis beginnen',
    login: 'Inloggen',
    goToDashboard: 'Naar dashboard',
    features: {
      quiz: 'Interactieve Quizzen',
      quizDesc: 'Maak boeiende quizzen met timer en scorebord',
      quizLive: 'Live Multiplayer Quizzen',
      quizLiveDesc: 'Organiseer live quizzen met gelijktijdig verbonden deelnemers',
      questionnaire: 'Conditionele Vragenlijsten',
      questionnaireDesc: 'Slimme formulieren met voorwaardelijke logica',
      events: 'Cadeaulijsten',
      eventsDesc: 'Maak lijsten voor bruiloften, verjaardagen en al uw evenementen'
    },
    highlights: {
      timer: 'Aanpasbare timer',
      realTimeScores: 'Realtime scores',
      kahootMusic: 'Kahoot-muziek',
      presenterMode: 'Presentator modus',
      liveRanking: 'Live ranking',
      upTo100Players: 'Tot 100 spelers',
      conditionalLogic: 'IF/ELSE logica',
      questionTypes: '11 vraagtypen',
      responseAnalysis: 'Antwoordanalyse',
      multiReservations: 'Meerdere reserveringen',
      photoGallery: 'Fotogalerij',
      pdfInvitations: 'PDF uitnodigingen'
    },
    eventTypes: {
      wedding: 'Bruiloft',
      birthday: 'Verjaardag',
      birth: 'Geboorte',
      baptism: 'Doop',
      housewarming: 'Housewarming',
      christmas: 'Kerstmis'
    },
    stats: {
      free: 'Gratis',
      unlimited: 'Onbeperkte quizzen',
      questionTypes: 'Vraagtypen',
      hdImages: 'HD afbeeldingen'
    },
    cta: {
      createFirstQuiz: 'Mijn eerste quiz maken',
      discoverFeatures: 'Functies ontdekken',
      watchDemo: 'Demo bekijken',
      createFreeAccount: 'Maak een gratis account',
      readyToCreate: 'Klaar om iets geweldigs te maken?',
      joinHugoQuiz: 'Word lid van HugoQuiz en transformeer uw evenementen in onvergetelijke ervaringen.',
      foreverFree: '100% gratis, voor altijd.'
    },
    footer: {
      madeWith: 'Gemaakt met',
      forYourEvents: 'voor uw evenementen',
      createdWith: 'Gemaakt met'
    },
    sections: {
      allYouNeed: 'Alles wat u nodig heeft',
      allYouNeedDesc: 'Een complete suite van tools voor onvergetelijke interactieve ervaringen',
      interactiveQuiz: 'Interactieve Quizzen',
      kahootStyle: 'Kahoot Stijl',
      quizDetailDesc: 'Maak boeiende quizzen met timer, scoresysteem, achtergrondmuziek en scoreborden. Perfect voor onderwijs, teambuilding of feestjes met vrienden!',
      giftLists: 'Cadeaulijsten',
      forAllEvents: 'Voor al uw evenementen',
      giftListDesc: 'Maak een elegante cadeaulijst, deel deze met uw dierbaren en laat hen gemakkelijk reserveren. Fotogalerij, gepersonaliseerd verhaal en PDF-uitnodigingen inbegrepen!',
      questionTypesTitle: '11 Vraagtypen',
      questionTypesDesc: 'Van klassieke vragen tot geavanceerde formulieren, alles is mogelijk',
      simpleAsHello: 'Simpel als hallo',
      createShareIn4Steps: 'Maak en deel in 4 stappen'
    },
    quizFeatures: {
      customTimer: 'Aanpasbare timer per vraag (5-120 sec)',
      kahootMusic: 'Ingebouwde Kahoot-stijl achtergrondmuziek',
      leaderboardBonus: 'Scorebord met snelheidsbonus',
      sevenQuestionTypes: '7 verschillende vraagtypen',
      mobileCompatible: 'Mobiel en tablet compatibel',
      musicOn: 'Muziek AAN',
      players: 'spelers'
    },
    giftFeatures: {
      photoGallery: 'Fotogalerij met geanimeerde diashow',
      pdfInvites: 'Gepersonaliseerde PDF-uitnodigingen',
      multiReservations: 'Meerdere reserveringen per cadeau',
      anonymousOption: 'Anonieme optie voor gasten',
      reservedBy: 'Gereserveerd door',
      persons: 'personen'
    },
    howItWorks: {
      step: 'Stap',
      step1Title: 'Aanmelden',
      step1Desc: 'Maak in 30 seconden een gratis account',
      step2Title: 'Maken',
      step2Desc: 'Quiz, vragenlijst of cadeaulijst',
      step3Title: 'Delen',
      step3Desc: 'Stuur de link naar uw deelnemers',
      step4Title: 'Analyseren',
      step4Desc: 'Bekijk resultaten in realtime'
    },
    navbar: {
      quiz: 'Quiz',
      events: 'Evenementen',
      gifts: 'Cadeaus',
      interactiveQuiz: 'Interactieve Quizzen',
      liveQuiz: 'Live Quiz',
      questionnaires: 'Vragenlijsten',
      giftLists: 'Cadeaulijsten',
      features: 'Functies'
    },
    // Hero section
    heroTitle: 'Creëer onvergetelijke ervaringen',
    // Quiz preview mockup
    quizPreview: {
      questionNumber: 'Vraag 3/10',
      sampleQuestion: 'Wat is de hoofdstad van Frankrijk?',
      option1: 'Parijs',
      option2: 'Londen',
      option3: 'Berlijn',
      option4: 'Madrid'
    },
    // Gift list preview mockup
    giftPreview: {
      weddingTitle: 'Bruiloft van Marie & Peter',
      weddingDate: '15 juni 2025',
      item1: 'Keukenmachine',
      item2: 'Serviesset',
      item3: 'Huwelijksreis',
      reservedBy1: 'Tante Sophie'
    },
    // Guest list preview mockup
    guestListPreview: {
      guest1: 'Marie Jansen',
      guest2: 'Peter de Vries',
      guest3: 'Sophie Bakker'
    },
    // Guestbook preview mockup
    guestbookPreview: {
      author1: 'Oma Johanna',
      message1: 'Gefeliciteerd mijn lieverds! 💕',
      author2: 'Thomas & Lea',
      message2: 'Een magische avond, bedankt!',
      author3: 'Oom Jan',
      message3: 'Lang leve het bruidspaar! 🥂'
    },
    // Guest list section
    guestList: {
      title: 'Gastenlijst',
      persons: 'pers.',
      confirmed: 'bevestigd',
      heading: 'Beheer uw gasten',
      subheading: 'met gemak',
      description: 'Volg bevestigingen, stuur herinneringen en exporteer uw lijst. Alles is gecentraliseerd voor perfecte organisatie.',
      feature1: 'Gepersonaliseerde e-mailuitnodigingen',
      feature2: 'Realtime bevestigingsopvolging',
      feature3: 'PDF- en Excel-export'
    },
    // Guestbook section
    guestbook: {
      heading: 'Digitaal gastenboek',
      subheading: 'Herinneringen voor altijd',
      description: 'Uw gasten laten hun berichten en foto\'s achter. Maak een uniek herinneringsalbum dat u voor altijd zult koesteren.',
      feature1: 'Tekst- en audioberichten',
      feature2: 'Foto\'s en video\'s van gasten',
      feature3: 'Aanpasbaar ontwerp',
      bookTitle: 'Gastenboek'
    },
    // Seating plan section
    seating: {
      heading: 'Interactief tafelplan',
      subheading: 'met tafelplaatsing',
      description: 'Maak uw tafelplan met slepen en neerzetten. Wijs uw gasten toe aan tafels en bekijk het resultaat in realtime.',
      feature1: 'Intuïtieve sleep-en-neerzet-interface',
      feature2: 'Automatische plaatstoewij zing',
      feature3: 'Exporteren en afdrukken van het plan',
      preview: 'Tafelplan',
      tables: 'tafels',
      seats: 'plaatsen',
      dragDrop: 'Slepen en neerzetten'
    },
    // Pro section
    pro: {
      badge: 'Pro-abonnement',
      heading: 'Naar een hoger niveau tillen',
      description: 'Ontgrendel alle functies en geniet van onbeperkte deelnemers voor uw quizzen en evenementen.',
      feature1Title: 'Onbeperkte deelnemers',
      feature1Desc: 'Geen limiet van 5 spelers meer',
      feature2Title: 'Vragenlijsten',
      feature2Desc: 'Maak complete enquêtes',
      feature3Title: 'Evenementen',
      feature3Desc: 'Cadeaulijsten, gasten, tafelplan',
      price: 'Vanaf €5',
      period: '/maand',
      cta: 'Bekijk abonnementen'
    }
  },
  
  // Footer
  footer: {
    description: 'Het interactieve platform voor het maken van quizzen, vragenlijsten en het beheren van uw evenementen.',
    support: 'Ondersteuning',
    legal: 'Juridisch',
    terms: 'Gebruiksvoorwaarden',
    privacy: 'Gegevensbescherming',
    help: 'Help',
    rights: 'Alle rechten voorbehouden.'
  },

  // Help
  help: {
    hero: {
      title: 'HugoQuiz Helpcentrum',
      subtitle: 'Ontdek alle functies van HugoQuiz en leer hoe u ze effectief kunt gebruiken om onvergetelijke evenementen te creëren.'
    },
    tabs: {
      faq: 'Veelgestelde vragen',
      docs: 'Volledige documentatie'
    },
    tips: {
      title: 'Tips om te beginnen',
      tip1: 'Begin met het maken van een eenvoudig evenement om vertrouwd te raken met de interface.',
      tip2: 'Gebruik quiz-sjablonen om tijd te besparen bij het maken.',
      tip3: 'Test uw quiz altijd in de voorbeeldmodus voordat u deze deelt.',
      tip4: 'Bekijk de statistieken na elk evenement om te verbeteren.'
    },
    faq: {
      title: 'Veelgestelde vragen',
      q1: {
        question: 'Hoe maak ik mijn eerste evenement?',
        answer: 'Om uw eerste evenement te maken, logt u in op uw HugoQuiz-account en klikt u op "Evenement maken" vanuit uw dashboard. Vul de basisinformatie in (naam, datum, locatie, beschrijving) en pas de opties aan naar uw behoeften. Daarna kunt u gasten toevoegen, een programma maken, tafels beheren en nog veel meer.'
      },
      q2: {
        question: 'Wat is het verschil tussen een live quiz en een asynchrone quiz?',
        answer: 'Een live quiz wordt in realtime gespeeld met alle deelnemers tegelijk verbonden. De host bepaalt het tempo en toont vragen één voor één. Ideaal voor feesten, bruiloften of teambuildings.\n\nEen asynchrone quiz stelt deelnemers in staat om in hun eigen tempo te spelen, wanneer ze maar willen. Iedereen beantwoordt vragen individueel en resultaten worden automatisch gecompileerd. Perfect voor trainingen of enquêtes.'
      },
      q3: {
        question: 'Hoe nodig ik deelnemers uit voor mijn evenement?',
        answer: 'U kunt deelnemers op verschillende manieren uitnodigen:\n• Handmatig contactgegevens toevoegen aan de gastenlijst\n• Een Excel/CSV-bestand importeren met de gastenlijst\n• Een uitnodigingslink of QR-code delen\n• E-mailuitnodigingen rechtstreeks vanuit HugoQuiz verzenden\n\nElke gast ontvangt gepersonaliseerde toegang met een unieke QR-code voor de dag van het evenement.'
      },
      q4: {
        question: 'Hoe werkt het tafel- en zitplaatsen-systeem?',
        answer: 'Het tafelbeheerssysteem stelt u in staat om:\n• Verschillende tafeltypen maken (rond, rechthoekig, vierkant)\n• Het aantal plaatsen per tafel definiëren\n• Gasten naar tafels slepen en neerzetten\n• Het zitplan in realtime bekijken\n• Gepersonaliseerde plaatskaartjes en het volledige plan afdrukken\n\nHet interactieve zitplan helpt u de indeling te optimaliseren en gastaffiniteiten te beheren.'
      },
      q5: {
        question: 'Kan ik het uiterlijk van mijn quizzen aanpassen?',
        answer: 'Ja, HugoQuiz biedt veel aanpassingsopties:\n• Kiezen uit verschillende visuele thema\'s\n• Uw logo en afbeeldingen toevoegen\n• Hoofdkleuren aanpassen\n• Achtergrondmuziek toevoegen\n• Tijd per vraag configureren\n• Eindberichten aanpassen\n\nHiermee kunt u een ervaring creëren die past bij uw evenementidentiteit.'
      },
      q6: {
        question: 'Hoe werkt het digitale gastenboek?',
        answer: 'Het digitale gastenboek stelt uw gasten in staat om berichten, foto\'s en video\'s achter te laten tijdens of na het evenement. Ze kunnen:\n• Gepersonaliseerde berichten schrijven\n• Foto\'s of selfies toevoegen\n• Spraakberichten opnemen\n• Reageren op berichten van anderen\n\nAlle herinneringen worden bewaard en u kunt ze exporteren als PDF of fotoalbum.'
      },
      q7: {
        question: 'Hoe scan ik tickets/QR-codes op de dag van het evenement?',
        answer: 'Op de dag van het evenement gebruikt u de functie "QR scannen" vanuit uw dashboard:\n• Sta cameratoegang toe op uw apparaat\n• Scan de QR-code van elke gast\n• Het systeem bevestigt onmiddellijk de geldigheid\n• De gast wordt automatisch gemarkeerd als "gearriveerd"\n• U ziet de aanwezigheidsgraad in realtime\n\nU kunt meerdere apparaten tegelijk gebruiken om het inchecken te versnellen.'
      },
      q8: {
        question: 'Hoe maak ik conditionele vragen in een vragenlijst?',
        answer: 'Conditionele vragen stellen u in staat om bepaalde vragen weer te geven op basis van eerdere antwoorden. Om ze te configureren:\n1. Maak uw hoofdvraag\n2. Schakel de optie "Conditionele vraag" in\n3. Definieer de voorwaarde (bijv. "Als antwoord = Ja")\n4. Selecteer de vraag die moet worden weergegeven als aan de voorwaarde is voldaan\n\nPerfect voor RSVP\'s (dieetbeperkingen alleen vragen als de persoon aanwezigheid bevestigt).'
      },
      q9: {
        question: 'Hoe werkt het abonnement en kan ik van plan wisselen?',
        answer: 'HugoQuiz biedt verschillende plannen:\n• Gratis: basisfuncties, perfect om te ontdekken\n• Premium: geavanceerde functies voor particulieren\n• Business: alle functies + prioriteitsondersteuning\n\nU kunt op elk moment van plan wisselen. De wijziging gaat onmiddellijk in en het bedrag wordt pro rata berekend.'
      },
      q10: {
        question: 'Zijn mijn gegevens veilig?',
        answer: 'Gegevensbeveiliging is onze prioriteit:\n• Gehost op beveiligde Europese servers\n• SSL/TLS-versleuteling voor alle communicatie\n• Volledige AVG-naleving\n• Dagelijkse automatische back-ups\n• Veilige authenticatie\n• Uw gegevens op elk moment verwijderen\n\nU blijft eigenaar van uw gegevens en kunt ze wanneer u wilt exporteren.'
      },
      q11: {
        question: 'Hoe voeg ik muziek toe aan mijn quiz?',
        answer: 'Om muziek aan uw quiz toe te voegen:\n1. Ga naar quiz-instellingen\n2. Sectie "Muziek en geluiden"\n3. Upload uw audiobestanden (MP3, WAV)\n4. Configureer muziek voor elke fase:\n   • Wachten op spelers\n   • Tijdens vragen\n   • Juist/onjuist antwoord\n   • Eindpodium\n\nU kunt ook de ingebouwde royaltyvrije muziekbibliotheek gebruiken.'
      },
      q12: {
        question: 'Hoe bekijk ik de statistieken van mijn evenement?',
        answer: 'Volledige statistieken zijn toegankelijk vanaf elke evenementpagina:\n• RSVP-responspercentage met tijdsverloop\n• Aanwezigheidsstatistieken op de dag\n• Gedetailleerde quizstatistieken (scores, responstijden)\n• Aanwezigheidspercentage op D-Day\n• Gastenboekberichten\n• Grafieken en trends\n\nU kunt deze statistieken exporteren als PDF of Excel voor uw archief.'
      },
      q13: {
        question: 'Kan ik HugoQuiz op mobiel gebruiken?',
        answer: 'Ja, HugoQuiz is volledig responsief en werkt perfect op:\n• Smartphones (iOS en Android)\n• Tablets\n• Computers\n\nDeelnemers kunnen quizzen spelen en functies openen vanaf elk apparaat met een moderne webbrowser. Geen app te installeren!'
      },
      q14: {
        question: 'Hoe neem ik contact op met support als ik een probleem heb?',
        answer: 'Verschillende opties om contact met ons op te nemen:\n• Live chat (pictogram rechtsonder)\n• E-mail: contact@hugoquiz.com\n• Online documentatie en tutorials\n\nOns team reageert meestal binnen 24 uur op werkdagen. Premium- en Business-abonnees krijgen prioriteitsondersteuning.'
      },
      q15: {
        question: 'Kan ik HugoQuiz gratis uitproberen voordat ik een abonnement neem?',
        answer: 'Absoluut! HugoQuiz biedt:\n• Een permanent gratis plan met essentiële functies\n• Een 7-daagse gratis proefperiode voor betaalde plannen\n• Geen creditcard vereist voor het gratis plan\n\nDe 7-daagse proefperiode geeft u toegang tot ALLE premium functies. U kunt op elk moment zonder kosten opzeggen tijdens de proefperiode.'
      }
    },
    docs: {
      events: {
        title: 'Evenementbeheer',
        description: 'Maak en beheer complete evenementen met alle benodigde functies.',
        guests: {
          title: 'Gastenlijst',
          content: 'Beheer uw gastenlijst efficiënt:\n\n• Gasten handmatig toevoegen of importeren vanuit Excel/CSV\n• Aanwezigheidsbevestigingen (RSVP) in realtime volgen\n• E-mailuitnodigingen verzenden met gepersonaliseerde QR-code\n• Begeleiders en kinderen beheren\n• Gasten categoriseren (familie, vrienden, collega\'s)\n• De volledige lijst op elk moment exporteren\n• Dieetbeperkingen en allergieën bijhouden'
        },
        gifts: {
          title: 'Cadeaulijst',
          content: 'Maak een gezamenlijke cadeaulijst:\n\n• Cadeau-ideeën toevoegen met foto\'s en links\n• Gasten kunnen een cadeau reserveren (alleen voor hen zichtbaar)\n• Duplicaten vermijden met het reserveringssysteem\n• Prioriteiten en categorieën instellen\n• Spaarpotten toevoegen voor grote cadeaus\n• Meldingen ontvangen wanneer een cadeau is gereserveerd\n• Gemakkelijk bedanken met geïntegreerde tracking'
        },
        tables: {
          title: 'Tafelbeheer',
          content: 'Organiseer uw receptie perfect:\n\n• Verschillende tafeltypen maken (rond, rechthoekig, cocktail)\n• Aantal plaatsen per tafel definiëren\n• Uw tafels benoemen (nummers, bloemnamen, steden...)\n• Gasten toewijzen met slepen en neerzetten\n• Resterende plaatsen bekijken\n• Gepersonaliseerde plaatskaartjes afdrukken\n• Last-minute wijzigingen eenvoudig beheren'
        },
        qrcode: {
          title: 'QR-scanner & Inchecken',
          content: 'Vereenvoudig het inchecken van gasten:\n\n• Elke gast ontvangt een unieke QR-code\n• Snel scannen met elke smartphone\n• Onmiddellijke visuele en audio bevestiging\n• Realtime aankomsttracking\n• Detectie van ongeldige of al gescande QR-codes\n• Live aanwezigheidsstatistieken\n• Meerdere incheckstations mogelijk'
        },
        seating: {
          title: 'Interactief Zitplan',
          content: 'Visualiseer en optimaliseer uw ruimte:\n\n• Intuïtieve drag & drop editor\n• Tafels, podium, dansvloer, buffet positioneren\n• Decoratieve elementen toevoegen (ingang, bar, fotohokje)\n• Elementen vrij schalen en oriënteren\n• Automatisch opslaan van wijzigingen\n• Overzicht voor grote ruimtes\n• Exporteren en afdrukken van het definitieve plan'
        },
        guestbook: {
          title: 'Digitaal Gastenboek',
          content: 'Verzamel waardevolle herinneringen:\n\n• Elegante interface voor berichten\n• Foto- en selfie-uploads door gasten\n• Optionele spraak- of videoberichten\n• Contentmoderatie indien nodig\n• Reacties en likes op berichten\n• PDF-export in herinneringsalbumformaat\n• Toegankelijk voor, tijdens en na het evenement'
        },
        stats: {
          title: 'Gedetailleerde Statistieken',
          content: 'Analyseer uw evenement diepgaand:\n\n• RSVP-responspercentage met tijdsverloop\n• Aanwezigheidsstatistieken op de dag\n• Vragenlijst- en quiz-analyse\n• Gastenboek-engagement\n• Visuele en exporteerbare grafieken\n• Vergelijking met uw eerdere evenementen\n• Key Performance Indicators (KPI\'s)'
        },
        planning: {
          title: 'Planning & Tijdlijn',
          content: 'Organiseer elk detail van uw evenement:\n\n• Maak een gedetailleerde tijdlijn\n• Stel mijlpalen en deadlines in\n• Wijs verantwoordelijken toe voor elke taak\n• Kalender- of lijstweergave naar voorkeur\n• Automatische e-mailherinneringen\n• Volg de algehele voortgang\n• Deel met uw leveranciers'
        },
        program: {
          title: 'Evenementprogramma',
          content: 'Communiceer het schema naar uw gasten:\n\n• Maak een gedetailleerd urenprogramma\n• Voeg pictogrammen en beschrijvingen toe\n• Definieer locaties voor elke activiteit\n• Programma toegankelijk via uitnodiging\n• Realtime updates bij wijzigingen\n• Optionele pushmeldingen\n• Afdrukbare versie beschikbaar'
        },
        menu: {
          title: 'Menu & Kaart',
          content: 'Presenteer uw menu elegant:\n\n• Maak meerdere menu\'s (volwassenen, kinderen, vegetarisch)\n• Voeg voorgerechten, hoofdgerechten, desserts, drankjes toe\n• Geef allergenen en herkomst aan\n• Integreer gerecht foto\'s\n• Menu zichtbaar voor gasten\n• Koppel keuzes aan RSVP-vragenlijst\n• PDF-export voor afdrukken'
        },
        tasks: {
          title: 'Taakbeheer',
          content: 'Vergeet niets voor de grote dag:\n\n• Maak takenlijsten per categorie\n• Wijs verantwoordelijken toe\n• Stel deadlines in\n• Volg voortgang per percentage\n• Ontvang automatische herinneringen\n• Vink voltooide taken af\n• Werk samen met uw organisatieteam'
        }
      },
      quiz: {
        title: 'Interactieve Quizzen',
        description: 'Maak uw evenementen levendig met leuke en boeiende quizzen.',
        create: {
          title: 'Quiz Maken',
          content: 'Maak boeiende quizzen in minuten:\n\n• Intuïtieve creatie-interface\n• Meerkeuzevragen, waar/onwaar, vrije tekst\n• Afbeeldingen en media aan vragen toevoegen\n• Responstijd per vraag instellen\n• Punten configureren op basis van moeilijkheid\n• Voorbeeld bekijken voor publicatie\n• Bestaande quizzen dupliceren en wijzigen'
        },
        live: {
          title: 'Live Modus (Realtime)',
          content: 'Host een live quiz als een pro:\n\n• Wachtkamer met achtergrondmuziek\n• Spelers nemen deel via code of QR-code\n• U bepaalt het vraagtempo\n• Gesynchroniseerde weergave op alle schermen\n• Realtime leaderboard tussen vragen\n• Deelnemerreacties en emoji\'s\n• Geanimeerd podium met muziek aan het einde\n• Perfect voor bruiloften, teambuildings, feesten'
        },
        async: {
          title: 'Asynchrone Modus',
          content: 'Laat spelers in hun eigen tempo deelnemen:\n\n• Deel een unieke link\n• Iedereen speelt wanneer ze willen\n• Beperkte of onbeperkte tijd per vraag\n• Scores worden automatisch verzameld\n• Leaderboard wordt continu bijgewerkt\n• Ideaal voor trainingen, herhaling, enquêtes\n• Resultaten op elk moment bekijkbaar'
        },
        leaderboard: {
          title: 'Leaderboard & Podium',
          content: 'Vier winnaars met stijl:\n\n• Realtime leaderboard tijdens quiz\n• Geanimeerd podium met visuele effecten\n• Aanpasbare overwinningmuziek\n• Weergave van scores en responstijden\n• Volledig leaderboard exporteren\n• Optionele deelnamecertificaten\n• Social media delen'
        },
        stats: {
          title: 'Quiz Statistieken',
          content: 'Analyseer prestaties in detail:\n\n• Percentage juiste antwoorden per vraag\n• Gemiddelde responstijd\n• Moeilijkste vragen\n• Score-evolutie\n• Sessievergelijking\n• Verbeterpunten identificeren\n• Gegevens exporteren voor diepgaande analyse'
        },
        music: {
          title: 'Muziek & Geluiden',
          content: 'Creëer een meeslepende sfeer:\n\n• Wachtkamermuziek\n• Aftellingsgeluiden\n• Goed/fout antwoord jingle\n• Spanningmuziek tussen vragen\n• Fanfare voor het podium\n• Ingebouwde royaltyvrije muziekbibliotheek\n• Uw eigen muziek uploaden'
        },
        media: {
          title: 'Afbeeldingen & Media',
          content: 'Verrijk uw vragen visueel:\n\n• Afbeeldingen aan vragen toevoegen\n• YouTube-video\'s insluiten\n• "Raad de afbeelding" vragen\n• Herbruikbare mediagalerij\n• Automatische beeldoptimalisatie\n• Ondersteuning voor gangbare formaten (JPG, PNG, GIF)\n• Opslag inbegrepen bij uw plan'
        },
        settings: {
          title: 'Geavanceerde Instellingen',
          content: 'Pas elk aspect van de quiz aan:\n\n• Maximum aantal deelnemers\n• Laatkomers toestaan of niet\n• Vraagvolgorde schudden\n• Antwoordvolgorde schudden\n• Tussentijdse scores tonen of verbergen\n• Donkere of lichte modus\n• Kleuraanpassing'
        }
      },
      questionnaire: {
        title: 'Slimme Vragenlijsten',
        description: 'Verzamel nauwkeurige informatie met flexibele formulieren.',
        create: {
          title: 'Vragenlijst Maken',
          content: 'Ontwerp professionele vragenlijsten:\n\n• Intuïtieve visuele editor\n• Slepen en neerzetten om te herschikken\n• Meerdere secties en pagina\'s\n• Aangepaste beschrijving en instructies\n• Realtime voorbeeld\n• Bestaande vragenlijsten dupliceren\n• Kant-en-klare sjablonen (RSVP, tevredenheid...)'
        },
        conditional: {
          title: 'Conditionele Vragen',
          content: 'Maak intelligente, gepersonaliseerde paden:\n\n• Vragen weergeven op basis van eerdere antwoorden\n• Voorbeeld: "Hoeveel begeleiders?" alleen als "Komt u? = Ja"\n• Meerdere voorwaarden (EN/OF)\n• Hele secties overslaan\n• Verschillende paden op basis van profiel\n• Logica zichtbaar in editor\n• Verschillende scenario\'s eenvoudig testen'
        },
        types: {
          title: 'Vraagtypen',
          content: 'Kies het formaat aangepast aan elke behoefte:\n\n• Enkele keuze (radio)\n• Meerdere keuzes (checkboxen)\n• Korte of lange tekst\n• E-mail, telefoon met validatie\n• Datum en tijd\n• Beoordelingsschaal (1-5, 1-10)\n• Bestandsupload\n• Rangschikking op voorkeursvolgorde'
        },
        results: {
          title: 'Resultaten & Analyse',
          content: 'Gebruik antwoorden effectief:\n\n• Statistiekenoverzicht\n• Grafieken per vraag\n• Volledige Excel/CSV-export\n• Filteren op criteria\n• Gedetailleerde individuele antwoorden\n• Tijdsevolutie van antwoorden\n• Automatische e-mailrapporten'
        },
        customization: {
          title: 'Aanpassing',
          content: 'Pas de vragenlijst aan uw merk aan:\n\n• Aangepast logo en kleuren\n• Gepersonaliseerd welkomstbericht\n• Aangepaste bevestigingspagina\n• Doorverwijzing na indiening\n• Aantal antwoorden beperken\n• Automatische sluitingsdatum\n• Optionele wachtwoordtoegang'
        }
      },
      account: {
        title: 'Mijn Account',
        description: 'Beheer uw profiel, abonnement en voorkeuren.',
        subscription: {
          title: 'Abonnement & Facturering',
          content: 'Beheer uw abonnement eenvoudig:\n\n• Huidig plan en limieten bekijken\n• Op elk moment van plan wisselen\n• Factuurgeschiedenis\n• Betalingsgegevens bijwerken\n• Annulering met terugbetaling binnen 30 min\n• 7-daagse gratis proefperiode beschikbaar\n• Prioriteitsondersteuning afhankelijk van plan'
        },
        security: {
          title: 'Accountbeveiliging',
          content: 'Bescherm uw account effectief:\n\n• Wachtwoord wijzigen\n• Inloggeschiedenis\n• Uitloggen van alle apparaten\n• Account en gegevens verwijderen\n• AVG-naleving gegarandeerd\n• Al uw gegevens exporteren\n• Tweefactorauthenticatie (binnenkort)'
        },
        notifications: {
          title: 'Meldingen',
          content: 'Blijf op de hoogte zonder overweldigd te worden:\n\n• Aanpasbare e-mailmeldingen\n• Alerts voor nieuwe antwoorden\n• Herinneringen voor komende evenementen\n• Taakmeldingen\n• Optionele wekelijkse samenvatting\n• In-app notificatiecentrum\n• Selectieve uitschakeling mogelijk'
        },
        support: {
          title: 'Ondersteuning & Hulp',
          content: 'We zijn er om te helpen:\n\n• Live chat met ons team\n• E-mailondersteuning binnen 24 uur\n• Volledige online documentatie\n• Stap-voor-stap video tutorials\n• Regelmatig bijgewerkte FAQ\n• Prioriteitsondersteuning voor Premium\n• Gepersonaliseerde Business-ondersteuning'
        }
      }
    },
    contact: {
      title: 'Meer hulp nodig?',
      description: 'Ons team staat klaar om al uw vragen te beantwoorden en u te helpen bij het gebruik van HugoQuiz.',
      email: 'Neem contact met ons op via e-mail'
    }
  },

  privacy: {
    title: 'Privacybeleid',
    lastUpdated: 'Laatst bijgewerkt:',
    intro: {
      title: 'Gegevensbescherming',
      description: 'Uw vertrouwen is belangrijk voor ons. Deze pagina legt uit hoe we uw persoonlijke gegevens verzamelen, gebruiken en beschermen wanneer u onze website en diensten gebruikt.'
    },
    section1: {
      title: '1. Verantwoordelijke voor de gegevensverwerking',
      description: 'De verantwoordelijke voor de verwerking van uw persoonlijke gegevens is:',
      website: 'Website:'
    },
    section2: {
      title: '2. Verzamelde gegevens',
      description: 'We verzamelen verschillende soorten gegevens om onze diensten te leveren:',
      email: {
        title: 'E-mailadres',
        description: 'Vereist voor accountcreatie en communicatie.'
      },
      username: {
        title: 'Gebruikersnaam',
        description: 'Openbare naam die wordt weergegeven bij quizzen en ranglijsten.'
      },
      password: {
        title: 'Wachtwoord',
        description: 'Veilig opgeslagen met hashing-algoritmen.'
      },
      payment: {
        title: 'Betalingsgegevens',
        description: 'Veilig verwerkt door Stripe, we slaan uw bankgegevens niet op.'
      },
      connection: {
        title: 'Verbindingsgegevens',
        description: 'IP-adres, browsertype, toegangstijden voor de beveiliging.'
      },
      content: {
        title: 'Gecreëerde inhoud',
        description: 'Quizzen, vragenlijsten, evenementen en antwoorden.'
      }
    },
    section3: {
      title: '3. Uw rechten',
      description: 'Onder de AVG heeft u de volgende rechten:',
      access: {
        title: 'Recht op inzage',
        description: 'U kunt een kopie van uw gegevens opvragen.'
      },
      rectification: {
        title: 'Recht op rectificatie',
        description: 'U kunt onjuiste gegevens laten corrigeren.'
      },
      erasure: {
        title: 'Recht op verwijdering',
        description: 'U kunt de verwijdering van uw gegevens aanvragen.'
      },
      portability: {
        title: 'Recht op gegevensoverdraagbaarheid',
        description: 'U kunt uw gegevens in een gestructureerd formaat ontvangen.'
      },
      restriction: {
        title: 'Recht op beperking van verwerking',
        description: 'U kunt verzoeken om beperking van de verwerking van uw gegevens.'
      },
      objection: {
        title: 'Recht van bezwaar',
        description: 'U kunt bezwaar maken tegen de verwerking van uw gegevens voor bepaalde doeleinden.'
      }
    },
    section4: {
      title: '4. Cookies en tracking',
      description: 'We gebruiken cookies om uw ervaring te verbeteren:',
      essential: {
        title: 'Essentiële cookies',
        description: 'Noodzakelijk voor het functioneren van de website (authenticatie, voorkeuren).'
      },
      analytics: {
        title: 'Analytische cookies',
        description: 'Helpen ons te begrijpen hoe de website wordt gebruikt (geanonimiseerd).'
      },
      preferences: {
        title: 'Voorkeurscookies',
        description: 'Bewaren uw voorkeuren (taal, thema).'
      }
    },
    section5: {
      title: '5. Gegevensbeveiliging',
      description: 'We implementeren robuuste beveiligingsmaatregelen:',
      encryption: {
        title: 'Versleuteling',
        description: 'HTTPS-versleuteling voor alle overdrachten.'
      },
      protection: {
        title: 'Bescherming',
        description: 'Bescherming tegen CSRF-, XSS- en SQL-injectieaanvallen.'
      },
      authentication: {
        title: 'Authenticatie',
        description: 'Veilige authenticatie via Firebase.'
      },
      hosting: {
        title: 'Hosting',
        description: 'Gegevens worden gehost in de EU op beveiligde Google Cloud-servers.'
      }
    },
    section6: {
      title: '6. Gegevensbewaring',
      description: 'Uw gegevens worden bewaard:',
      active: {
        title: 'Actief account',
        description: 'Zolang uw account actief is.'
      },
      deletion: {
        title: 'Na verwijdering',
        description: 'Gegevens worden binnen 30 dagen na een verzoek verwijderd.'
      },
      backups: {
        title: 'Back-ups',
        description: 'Back-ups worden maximaal 90 dagen bewaard.'
      }
    },
    section7: {
      title: '7. Gegevensdeling',
      description: 'We delen uw gegevens alleen met:',
      stripe: {
        title: 'Stripe',
        description: 'Voor veilige betalingsverwerking.'
      },
      firebase: {
        title: 'Firebase/Google',
        description: 'Voor hosting en authenticatie.'
      },
      legal: {
        title: 'Wettelijke vereisten',
        description: 'Bij wettelijke verplichting.'
      }
    },
    section8: {
      title: '8. Contact',
      description: 'Voor vragen over uw gegevens:',
      email: 'E-mail:',
      response: 'We zullen binnen 30 dagen op elk verzoek reageren.'
    }
  },

  cgu: {
    title: 'Algemene Gebruiksvoorwaarden',
    lastUpdated: 'Laatst bijgewerkt:',
    article1: {
      title: 'Artikel 1 - Onderwerp',
      p1: 'Deze Algemene Gebruiksvoorwaarden (hierna "AGV" genoemd) regelen het gebruik van de website HugoQuiz, toegankelijk op het adres hugoquiz.com.',
      p2: 'Door de website te gebruiken, erkent u deze AGV volledig te hebben gelezen en geaccepteerd.'
    },
    article2: {
      title: 'Artikel 2 - Toegang tot de website',
      p1: 'De website is toegankelijk voor iedereen met een internetverbinding. Alle kosten verbonden aan toegang tot de website, of het nu gaat om hardware, software of internettoegang, zijn volledig voor rekening van de gebruiker.',
      p2: 'Toegang tot bepaalde diensten vereist het aanmaken van een gebruikersaccount. De gebruiker verbindt zich ertoe nauwkeurige informatie te verstrekken en deze actueel te houden.'
    },
    article3: {
      title: 'Artikel 3 - Intellectueel eigendom',
      p1: 'Alle elementen van de website HugoQuiz (teksten, afbeeldingen, logo\'s, grafieken, pictogrammen, geluiden, software, enz.) zijn beschermd door Franse en internationale wetgeving inzake intellectueel eigendom.',
      p2: 'Elke volledige of gedeeltelijke reproductie, weergave, wijziging, publicatie of aanpassing van de elementen van de website is verboden zonder voorafgaande schriftelijke toestemming van de eigenaar.'
    },
    article4: {
      title: 'Artikel 4 - Verantwoordelijkheden',
      p1: 'De uitgever van de website HugoQuiz streeft ernaar, voor zover mogelijk, nauwkeurige en actuele informatie te verstrekken. Hij kan echter niet aansprakelijk worden gesteld voor fouten, weglatingen of resultaten die voortvloeien uit het gebruik van deze informatie.',
      p2: 'De gebruiker is verantwoordelijk voor het gebruik van de website en verbindt zich ertoe geen illegale inhoud te publiceren of te verspreiden.'
    },
    article4bis: {
      title: 'ARTIKEL 4 BIS – GRATIS PROEFPERIODE',
      section1Title: '4 bis.1. VOORWAARDEN VAN DE GRATIS PROEFPERIODE',
      section1Desc: 'De Uitgever biedt nieuwe Gebruikers de mogelijkheid om te profiteren van een gratis proefperiode van ZEVEN (7) DAGEN voor elk maandabonnement. Dit aanbod is onderworpen aan de volgende voorwaarden:',
      section1Item1: 'De gratis proefperiode is slechts EENMAAL per Gebruiker beschikbaar, ongeacht het gekozen abonnement;',
      section1Item2: 'Als de Gebruiker een gratis proefperiode activeert voor één abonnement, verliest hij/zij permanent het recht op een gratis proefperiode voor alle andere abonnementen;',
      section1Item3: 'Registratie van een betaalmethode (creditcard) is verplicht om de gratis proefperiode te activeren;',
      section1Item4: 'Gebruikers die gratis premium-toegang hebben ontvangen van de beheerder kunnen niet profiteren van de gratis proefperiode.',
      section2Title: '4 bis.2. DUUR EN WERKING',
      section2Desc: 'Tijdens de zeven (7) dagen proefperiode:',
      section2Item1: 'De Gebruiker profiteert van alle functies van het gekozen abonnement;',
      section2Item2: 'Er wordt geen betaling afgeschreven tijdens de proefperiode;',
      section2Item3: 'De Gebruiker kan op elk moment vóór het einde van de proefperiode kosteloos opzeggen.',
      section3Title: '4 bis.3. EINDE VAN DE PROEFPERIODE',
      section3Desc: 'Aan het einde van de zeven (7) dagen proefperiode:',
      section3Item1: 'De eerste betaling wordt automatisch afgeschreven om 00:00 uur (Parijse tijd) op de achtste (8e) dag na activering van de proefversie;',
      section3Item2: 'Het Abonnement wordt vervolgens automatisch verlengd volgens de voorwaarden in Artikel 4.3;',
      section3Item3: 'De Gebruiker wordt per e-mail op de hoogte gesteld vóór het einde van de proefperiode.',
      section4Title: '4 bis.4. OPZEGGING TIJDENS DE PROEFPERIODE',
      section4Desc: 'De Gebruiker kan zijn/haar gratis proefperiode op elk moment tijdens de zeven (7) dagen opzeggen via zijn/haar persoonlijke ruimte. Bij opzegging tijdens de proefperiode:',
      section4Item1: 'Er wordt geen betaling afgeschreven;',
      section4Item2: 'De toegang tot premium-functies eindigt onmiddellijk;',
      section4Item3: 'De Gebruiker kan niet langer profiteren van een nieuwe gratis proefperiode, zelfs niet voor een ander abonnement.',
      section5Title: '4 bis.5. BESCHERMING TEGEN MISBRUIK',
      section5Desc: 'Om misbruik te voorkomen, implementeert de Uitgever de volgende beschermingsmaatregelen:',
      section5Item1: 'De geschiktheid voor de gratis proefperiode wordt server-side geverifieerd en kan niet worden omzeild;',
      section5Item2: 'Het annuleren van de gratis proefperiode maakt het niet mogelijk om een nieuwe te activeren;',
      section5Item3: 'De Uitgever behoudt zich het recht voor om een gratis proefperiode te weigeren of te annuleren bij vermoeden van fraude.'
    },
    article5: {
      title: 'ARTIKEL 5 – HERROEPINGSRECHT, OPZEGGING EN TERUGBETALING',
      section1Title: '5.1. BEPERKT HERROEPINGSRECHT',
      section1Desc: 'Overeenkomstig de bepalingen van het consumentenrecht en gezien de aard van de aangeboden Diensten (digitale inhoud die niet op een materiële drager wordt geleverd en waarvan de uitvoering is begonnen met de voorafgaande uitdrukkelijke toestemming van de consument), beschikt de Gebruiker over een beperkt herroepingsrecht onder de volgende voorwaarden:',
      section1Important: 'Een volledige terugbetaling van het Abonnement is alleen mogelijk als het annuleringsverzoek binnen DERTIG (30) MINUTEN na het oorspronkelijke afsluiten van het Abonnement wordt ingediend. Na deze termijn wordt voor de lopende Abonnementsperiode geen terugbetaling verleend.',
      section2Title: '5.2. OPZEGGING VAN DE VERLENGING',
      section2Desc: 'De Gebruiker kan op elk moment, zonder enige termijnbeperking, via zijn/haar persoonlijke ruimte beslissen om zijn/haar Abonnement niet te verlengen:',
      section2Important: 'De annulering van de automatische verlenging is OP ELK MOMENT mogelijk, ook in de uren voorafgaand aan de verlengingsdatum. Zodra de annulering is voltooid, vindt er geen nieuwe afschrijving plaats en behoudt de Gebruiker toegang tot de Diensten tot het einde van de lopende Abonnementsperiode. Er wordt geen terugbetaling gedaan.',
      section3Title: '5.3. GEEN TERUGBETALING',
      section3Desc: 'De Gebruiker behoudt het recht om zijn/haar Abonnement op elk moment op te zeggen. Indien de opzegging echter plaatsvindt:',
      section3Item1: 'Meer dan dertig (30) minuten na het oorspronkelijke afsluiten; of',
      section3Item2: 'Na het begin van een reeds betaalde Abonnementsperiode; of',
      section3Item3: 'Na een automatische verlenging van het Abonnement',
      section3NoRefund: 'Er wordt geen terugbetaling, ook geen gedeeltelijke of pro rata, verleend.',
      section4Title: '5.4. BELANGRIJKE PRECISERINGEN',
      section4Desc: 'Het herroepingsrecht met terugbetaling van dertig (30) minuten is uitsluitend van toepassing op het oorspronkelijke afsluiten van een Abonnement en niet op latere automatische verlengingen.',
      section5Title: '5.5. ONMIDDELLIJKE BEËINDIGING VAN HET ABONNEMENT',
      section5Desc: 'De Gebruiker kan zijn/haar abonnement op elk moment en zonder beperking onmiddellijk beëindigen via zijn/haar persoonlijke ruimte. In dat geval:',
      section5Item1: 'Het verlies van de voordelen en functies van het abonnement is ONMIDDELLIJK;',
      section5Item2: 'Er is geen terugbetaling, ook geen gedeeltelijke, mogelijk;',
      section5Item3: 'De Gebruiker keert onmiddellijk terug naar het gratis abonnement en ontvangt een bevestiging per e-mail.'
    },
    article6: {
      title: 'Artikel 6 - Persoonsgegevens',
      p1: 'Het verzamelen en verwerken van persoonsgegevens gebeurt in overeenstemming met ons Privacybeleid.',
      p2: 'Onder de privacywetgeving heeft u recht op toegang, rectificatie en verwijdering van uw persoonsgegevens.'
    },
    article7: {
      title: 'Artikel 7 - Cookies',
      p1: 'De website HugoQuiz gebruikt cookies om uw gebruikerservaring te verbeteren. Door verder te browsen op de website, stemt u in met het gebruik van cookies.',
      p2: 'U kunt uw browser configureren om cookies te weigeren, maar sommige functies van de website zijn dan mogelijk niet beschikbaar.'
    },
    article8: {
      title: 'Artikel 8 - Hyperlinks',
      p1: 'De website kan hyperlinks naar andere websites bevatten. HugoQuiz is niet verantwoordelijk voor de inhoud van deze externe websites.',
      p2: 'Het maken van hyperlinks naar de website HugoQuiz is toegestaan zonder voorafgaande toestemming, op voorwaarde dat dit de belangen van de uitgever niet schaadt.'
    },
    article9: {
      title: 'Artikel 9 - Wijzigingen van de AGV',
      p1: 'HugoQuiz behoudt zich het recht voor om deze Algemene Gebruiksvoorwaarden op elk moment te wijzigen. Voortgezet gebruik van de website na wijzigingen geldt als aanvaarding van de nieuwe voorwaarden.',
      p2: 'Gebruikers worden op de hoogte gebracht van belangrijke wijzigingen via e-mail of via een melding op de website.'
    },
    article10: {
      title: 'Artikel 10 - Toepasselijk recht',
      p1: 'Deze Algemene Gebruiksvoorwaarden zijn onderworpen aan Frans recht. In geval van geschillen zijn de Franse rechtbanken exclusief bevoegd.',
      p2: 'Als een bepaling van deze AGV onwettig, ongeldig of niet-afdwingbaar is, blijven de overige bepalingen volledig van kracht.'
    },
    article10bis: {
      title: 'Artikel 10bis - Verwijdering van account',
      section1: '10bis.1. Verwijdering op verzoek van de gebruiker',
      section1Desc: 'Elke gebruiker kan op elk moment de verwijdering van zijn account aanvragen via de instellingen.',
      section2: '10bis.2. Gevolgen van verwijdering',
      section2Desc: 'Bij verwijdering van het account:',
      section2Items: 'Persoonsgegevens worden binnen 30 dagen definitief verwijderd. Gecreëerde inhoud (quizzen, vragenlijsten, evenementen) wordt onherroepelijk verwijderd. Lopende abonnementen worden beëindigd, geen terugbetaling bij zelfverwijdering.',
      section3: '10bis.3. Verwijdering door administratie',
      section3Desc: 'HugoQuiz behoudt zich het recht voor om accounts te verwijderen bij ernstige of herhaalde schendingen van deze AGV.',
      section4: '10bis.4. Inactiviteitsperiode',
      section4Desc: 'Na 24 maanden inactiviteit kan het account zonder voorafgaande kennisgeving worden verwijderd.',
      section5: '10bis.5. Verwijderde gegevens',
      section5Desc: 'Na verwijdering zijn de volgende gegevens onherroepelijk verloren:',
      section5Items: 'Quizzen en vragenlijsten. Evenementen en gastenlijsten. Punten en ranglijsten. Betalingsgeschiedenis (alleen samenvattende bewaring voor 10 jaar). Prestatiestatistieken.',
      section6: '10bis.6. Gegevensback-up voor verwijdering',
      section6Desc: 'U kunt een volledige export van uw gegevens aanvragen voor verwijdering. Dit verzoek moet ten minste 15 dagen voor de verwijdering van het account worden ingediend.'
    },
    article11: {
      title: 'Artikel 11 - Verboden gedrag',
      p1: 'Gebruikers verbinden zich ertoe:',
      items: 'Geen illegale, lasterlijke, beledigende of pornografische inhoud te publiceren. De website niet voor illegale doeleinden te gebruiken. Niet te proberen ongeautoriseerde toegang te krijgen tot de systemen van de website. De ervaring van andere gebruikers niet te verstoren.',
      p2: 'Bij overtreding van deze regels kan het gebruikersaccount onmiddellijk worden opgeschort of beëindigd.'
    },
    article12: {
      title: 'Artikel 12 - Contact',
      p1: 'Voor alle vragen over deze Algemene Gebruiksvoorwaarden kunt u contact met ons opnemen:',
      p2: 'We zullen zo snel mogelijk op uw verzoeken reageren.'
    },
    servicesSection: {
      title: 'Artikel 10 ter - Marktplaats "Services"',
      purposeTitle: 'Doel',
      purpose: "HugoQuiz biedt een marktplaats waarop gebruikers (de \"Aanbieders\") hun diensten kunnen aanbieden aan andere gebruikers of bezoekers. HugoQuiz treedt uitsluitend op als technische bemiddelingshost en is geen partij bij de overeenkomsten tussen Aanbieders en klanten. Het bekijken van services is vrij; het aanmaken van een service vereist een account en voorafgaande verificatie van de identiteit van de Aanbieder.",
      verificationTitle: 'Identiteitsverificatie',
      verification: "Om een service te publiceren, moet de Aanbieder een geldig officieel identiteitsbewijs (identiteitskaart, paspoort van de Europese Unie, verblijfsvergunning, visum of rijbewijs) en een korte selfievideo aanleveren. Deze worden uitsluitend gebruikt om te bevestigen dat de opgegeven identiteit overeenkomt met de persoon. Elke service wordt vóór publicatie door ons team beoordeeld.",
      prohibitedTitle: 'Verboden diensten',
      prohibitedIntro: 'Het volgende is strikt verboden en wordt geweigerd, beperkt of onmiddellijk verwijderd, onverminderd juridische stappen:',
      prohibited1: 'elke dienst van seksuele, pornografische of escortaard;',
      prohibited2: 'de verkoop, productie of distributie van drugs, verdovende middelen of illegale substanties;',
      prohibited3: 'de verkoop van wapens, explosieven of gereguleerde gevaarlijke goederen;',
      prohibited4: 'elke dienst die in strijd is met de wet of illegaal is in de Europese Unie of in het land van uitvoering;',
      prohibited5: 'inhoud of activiteiten die aanzetten tot haat, geweld, discriminatie of die de rechten van anderen schenden;',
      prohibited6: 'elke oplichting, vervalsing, witwassen of frauduleuze activiteit.',
      responsibilityTitle: 'Verantwoordelijkheid van Aanbieders',
      responsibility: "De Aanbieder is als enige verantwoordelijk voor de wettigheid, juistheid en uitvoering van de diensten die hij aanbiedt, evenals voor de naleving van zijn wettelijke, fiscale en regelgevende verplichtingen. HugoQuiz behoudt zich het recht voor om elke service te modereren, te beperken of te verwijderen en elk account op te schorten bij schending van deze voorwaarden, met automatische kennisgeving aan de betrokken gebruiker.",
      dataTitle: 'Gegevens en contactformulier',
      data: "Openbaar weergegeven contactgegevens (e-mail, telefoon) worden naar keuze van de Aanbieder getoond. Wanneer een bezoeker een aanvraag verzendt via het contactformulier van een service, worden de verstrekte gegevens (naam, telefoon, type klant, onderwerp en beschrijving van de aanvraag) via een melding en e-mail doorgestuurd naar de betreffende Aanbieder om het contact mogelijk te maken. Door het formulier in te dienen, stemt de gebruiker uitdrukkelijk in met deze verwerking en doorgifte. Identiteitsbewijzen en verificatievideo's worden vertrouwelijk bewaard en zijn alleen toegankelijk voor het moderatieteam van HugoQuiz, in overeenstemming met het privacybeleid."
    }
  },

  auth: {
    email: 'E-mail',
    emailPlaceholder: 'uw@email.com',
    password: 'Wachtwoord',
    confirmPassword: 'Wachtwoord bevestigen',
    displayName: 'Weergavenaam',
    displayNamePlaceholder: 'Jan Jansen',
    loginTitle: 'Inloggen',
    registerTitle: 'Account maken',
    loginButton: 'Inloggen',
    registerButton: 'Registreren',
    forgotPassword: 'Wachtwoord vergeten?',
    forgotPasswordTitle: 'Wachtwoord vergeten',
    resetPasswordDesc: 'Voer uw e-mail in om te resetten',
    noAccount: 'Nog geen account?',
    hasAccount: 'Al een account?',
    pendingValidation: 'Account wacht op validatie',
    pendingMessage: 'Uw account wordt gecontroleerd door een beheerder.',
    backToHome: 'Terug naar home',
    backToLogin: 'Terug naar inloggen',
    welcomeTo: 'Welkom bij',
    joinHugoQuiz: 'Word lid van HugoQuiz',
    createAccount: 'Mijn account maken',
    sendResetLink: 'Link verzenden',
    passwordRequirements: {
      minLength: 'Minimaal 6 tekens',
      uppercase: 'Eén hoofdletter',
      number: 'Eén cijfer'
    },
    errors: {
      fillAllFields: 'Vul alle velden in',
      fillAddressFields: 'Vul alle adresvelden in',
      passwordMin6: 'Wachtwoord moet minimaal 6 tekens bevatten',
      passwordNoMatch: 'Wachtwoorden komen niet overeen',
      userNotFound: 'Geen account gevonden met dit e-mailadres',
      wrongPassword: 'Verkeerd wachtwoord',
      invalidCredential: 'Ongeldige e-mail of wachtwoord',
      connectionError: 'Verbindingsfout',
      emailAlreadyUsed: 'Dit e-mailadres is al in gebruik',
      invalidEmail: 'Ongeldig e-mailadres',
      invalidEmailFormat: 'Ongeldig e-mailformaat',
      weakPassword: 'Wachtwoord te zwak',
      registerError: 'Fout bij registratie',
      enterEmail: 'Voer uw e-mailadres in',
      noAccountForEmail: 'Geen account gekoppeld aan dit e-mailadres',
      tooManyAttempts: 'Te veel pogingen. Probeer het later opnieuw.',
      resetError: 'Fout bij verzenden van reset-e-mail'
    },
    success: {
      loginSuccess: 'Succesvol ingelogd!',
      resetEmailSent: 'Reset e-mail verzonden! Controleer uw inbox en spammap.',
      verificationSent: 'Er is een verificatie-e-mail verzonden naar'
    },
    passwordMismatch: 'Wachtwoorden komen niet overeen',
    loginError: 'Ongeldige e-mail of wachtwoord',
    emailInUse: 'Deze e-mail is al in gebruik',
    invalidEmail: 'Ongeldige e-mail',
    weakPassword: 'Wachtwoord te zwak',
    verificationSent: 'Er is een verificatie-e-mail verzonden naar',
    adminValidation: 'Na registratie moet uw account worden gevalideerd door een beheerder.',
    address: {
      title: 'Bezorgadres',
      street: 'Straat',
      streetNumber: 'Nummer',
      postalCode: 'Postcode',
      city: 'Stad',
      nameAtAddress: 'Naam op adres',
      nameAtAddressHint: 'Naam die op leveringen verschijnt',
      postalNotRecognized: 'Postcode niet herkend maar geaccepteerd'
    }
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welkom',
    hello: 'Hallo',
    manageContent: 'Beheer uw quizzen en vragenlijsten',
    myQuizzes: 'Mijn Quizzen',
    myQuestionnaires: 'Mijn Vragenlijsten',
    myEvents: 'Mijn Evenementen',
    createQuiz: 'Quiz maken',
    createQuestionnaire: 'Vragenlijst maken',
    createEvent: 'Evenement maken',
    noQuizzes: 'U heeft nog geen quizzen gemaakt',
    noQuestionnaires: 'U heeft nog geen vragenlijsten gemaakt',
    noEvents: 'U heeft nog geen evenementen gemaakt',
    noQuizzesDesc: 'Maak uw eerste interactieve quiz',
    noQuestionnairesDesc: 'Maak uw eerste vragenlijst',
    noEventsDesc: 'Maak uw eerste evenement',
    createFirstQuiz: 'Mijn eerste quiz maken',
    createFirstQuestionnaire: 'Mijn eerste vragenlijst maken',
    createFirstEvent: 'Mijn eerste evenement maken',
    recentActivity: 'Recente activiteit',
    quickActions: 'Snelle acties',
    noDescription: 'Geen beschrijving',
    dateNotSet: 'Datum niet ingesteld',
    stats: {
      quizzesCreated: 'Gemaakte quizzen',
      questionnaires: 'Vragenlijsten',
      events: 'Evenementen',
      totalContent: 'Totale inhoud',
      totalQuizzes: 'Totaal Quizzen',
      totalQuestionnaires: 'Totaal Vragenlijsten',
      totalEvents: 'Totaal Evenementen',
      totalResponses: 'Totaal Antwoorden',
      totalParticipants: 'Totaal Deelnemers',
      totalGuests: 'Totaal Gasten'
    },
    tabs: {
      quiz: 'Quiz',
      questionnaires: 'Vragenlijsten',
      events: 'Evenementen',
      services: 'Services'
    },
    actions: {
      hostLive: 'Live hosten',
      viewResponses: 'Antwoorden bekijken',
      share: 'Delen',
      play: 'Spelen',
      answer: 'Beantwoorden',
      edit: 'Bewerken',
      delete: 'Verwijderen',
      manageGuests: 'Gasten beheren',
      statistics: 'Statistieken',
      view: 'Bekijken'
    },
    actionPanel: {
      hostLive: 'Live starten',
      testQuiz: 'Quiz testen',
      viewResults: 'Resultaten bekijken',
      share: 'Delen',
      edit: 'Bewerken',
      delete: 'Verwijderen',
      viewResponses: 'Antwoorden bekijken',
      test: 'Testen',
      guestList: 'Gastenlijst',
      planning: 'Planning',
      tasks: 'Taken',
      statistics: 'Statistieken',
      shareGiftList: 'Delen',
      viewGiftList: 'Bekijken'
    },
    share: {
      title: 'Delen',
      whatsapp: 'Delen op WhatsApp',
      email: 'Verzenden per e-mail',
      copyLink: 'Link kopiëren',
      linkCopied: 'Link gekopieerd!',
      copyError: 'Kan link niet kopiëren',
      quizMessage: 'Speel mijn quiz',
      questionnaireMessage: 'Beantwoord mijn vragenlijst',
      eventMessage: 'Bekijk onze cadeaulijst',
      quizEmailSubject: 'Quiz uitnodiging',
      quizEmailBody: 'Hallo,\n\nIk nodig u uit om mijn quiz "{title}" te spelen!\n\nKlik op de volgende link om te beginnen:\n{link}\n\nVeel succes! 🎯',
      questionnaireEmailSubject: 'Vragenlijst uitnodiging',
      questionnaireEmailBody: 'Hallo,\n\nIk nodig u uit om mijn vragenlijst "{title}" te beantwoorden.\n\nKlik op de volgende link om deel te nemen:\n{link}\n\nBedankt voor uw deelname! 📋',
      eventEmailSubject: 'Cadeaulijst',
      eventEmailBody: 'Hallo,\n\nU bent uitgenodigd om onze cadeaulijst voor "{title}" te bekijken!\n\nKlik op de volgende link om de lijst te zien en een cadeau te reserveren:\n{link}\n\nHartelijk dank! 🎁'
    },
    deleteModal: {
      title: 'Verwijderen bevestigen',
      message: 'Weet u zeker dat u "{title}" wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
      cancel: 'Annuleren',
      confirm: 'Verwijderen',
      success: 'Succesvol verwijderd',
      error: 'Fout bij verwijderen'
    },
    eventTypes: {
      mariage: 'Bruiloft',
      anniversaire: 'Verjaardag',
      naissance: 'Geboorte',
      bapteme: 'Doop',
      cremaillere: 'Housewarming',
      noel: 'Kerstmis',
      autre: 'Andere'
    },
    loading: 'Laden...',
    loadError: 'Fout bij laden van gegevens'
  },
  quiz: {
    title: 'Quiz titel',
    description: 'Beschrijving',
    questions: 'Vragen',
    question: 'Vraag',
    answers: 'Antwoorden',
    answer: 'Antwoord',
    correctAnswer: 'Juist antwoord',
    wrongAnswer: 'Fout antwoord',
    timeLimit: 'Tijdslimiet',
    timeLimitSeconds: 'seconden',
    points: 'Punten',
    addQuestion: 'Vraag toevoegen',
    play: 'Quiz spelen',
    playLive: 'Live Quiz',
    results: 'Resultaten',
    score: 'Score',
    leaderboard: 'Scorebord',
    yourAnswer: 'Uw antwoord',
    correct: 'Correct',
    incorrect: 'Incorrect',
    timeUp: 'Tijd voorbij!',
    nextQuestion: 'Volgende vraag',
    finish: 'Voltooien',
    true: 'Waar',
    false: 'Onwaar',
    // Play mode translations
    yourName: 'Uw naam',
    enterNamePlaceholder: 'Voer uw naam in...',
    prepareToPlay: 'Maak u klaar om te spelen!',
    loading: 'Quiz laden...',
    checkAllCorrect: 'Vink alle juiste antwoorden aan',
    validateAnswer: 'Mijn antwoord bevestigen',
    selectAnswer: '-- Selecteer een antwoord --',
    correctAnswerWas: 'Het juiste antwoord was',
    typeYourAnswer: 'Typ uw antwoord...',
    enterNumber: 'Voer een nummer in...',
    validate: 'Bevestigen',
    selectAtLeastOne: 'Selecteer minimaal één antwoord',
    enterAnswer: 'Voer een antwoord in',
    enterValidNumber: 'Voer een geldig nummer in',
    selectRating: 'Selecteer een beoordeling',
    puzzleReorder: 'In volgorde plaatsen',
    puzzleInstruction: 'Gebruik de pijlen om de elementen te herordenen',
    validateOrder: 'Mijn volgorde bevestigen',
    correctOrder: 'Juiste volgorde',
    bravo: 'Goed gedaan',
    answerDetails: 'Antwoorddetails',
    replay: 'Opnieuw spelen',
    questionTypes: {
      singleChoice: 'Enkele keuze',
      singleChoiceDesc: 'Eén antwoord mogelijk',
      multipleChoice: 'Meervoudige keuze',
      multipleChoiceDesc: 'Meerdere antwoorden mogelijk',
      trueFalse: 'Waar of Onwaar',
      trueFalseDesc: 'Waar of onwaar vraag',
      dropdown: 'Dropdown lijst',
      dropdownDesc: 'Selectie uit een lijst',
      shortText: 'Korte tekst',
      shortTextDesc: 'Vrij kort antwoord',
      number: 'Numeriek antwoord',
      numberDesc: 'Een getal als antwoord',
      rating: 'Beoordeling',
      ratingDesc: 'Score op een schaal',
      puzzle: 'Volgorde',
      puzzleDesc: 'Elementen in volgorde plaatsen'
    },
    create: {
      title: 'Quiz maken',
      editTitle: 'Quiz bewerken',
      editSubtitle: 'Vragen en instellingen bewerken',
      quizInfo: 'Quiz Informatie',
      quizTitle: 'Quiz titel',
      quizTitlePlaceholder: 'Bijv.: Algemene kennis quiz',
      quizDescription: 'Beschrijving (optioneel)',
      quizDescriptionPlaceholder: 'Beschrijf uw quiz...',
      defaultTime: 'Standaard tijd per vraag',
      timeSeconds: 'Tijd (sec)',
      isPublic: 'Openbare quiz',
      isPublicDesc: 'Zichtbaar voor alle gebruikers',
      showAnswers: 'Antwoorden tonen',
      shuffle: 'Willekeurig',
      addImage: 'Afbeelding toevoegen',
      questionText: 'Vraagtekst',
      questionTextPlaceholder: 'Voer uw vraag in...',
      noQuestionText: 'Vraag zonder tekst',
      questionImage: 'Vraagafbeelding',
      imageTip: 'De afbeelding wordt aan spelers getoond tijdens de vraag',
      questionType: 'Vraagtype',
      answerOptions: 'Antwoordopties',
      answerPlaceholder: 'Antwoord',
      addOption: 'Optie toevoegen',
      addAnswer: 'Antwoord toevoegen',
      addElement: 'Element toevoegen',
      markCorrect: 'Markeer als correct',
      puzzleElements: 'Te ordenen elementen',
      puzzleOrderHint: 'de hier getoonde volgorde = de juiste volgorde',
      puzzleTip: 'Voer elementen in de JUISTE VOLGORDE in. Spelers zien ze door elkaar en moeten ze in deze volgorde plaatsen.',
      acceptedAnswers: 'Geaccepteerde juiste antwoorden',
      acceptedAnswersPlaceholder: 'Voer geaccepteerde antwoorden in gescheiden door komma\'s...\nVoorbeeld: Parijs, parijs, PARIJS',
      acceptedAnswersTip: 'Scheid verschillende geaccepteerde spellingen met komma\'s.',
      correctNumber: 'Juist antwoord (exact getal)',
      correctStars: 'Juist antwoord (aantal sterren)',
      questionDuration: 'Vraagduur',
      questionDuplicated: 'Vraag gedupliceerd',
      maxOptions: 'Maximaal 6 opties',
      minAnswers: 'Minimaal 2 opties vereist',
      minQuestions: 'Quiz moet minimaal één vraag hebben',
      titleRequired: 'Voer een quiz titel in',
      questionTextRequired: 'Voer de vraagtekst in',
      minOptionsRequired: 'Minimaal 2 opties zijn vereist',
      selectCorrect: 'Selecteer minimaal één juist antwoord',
      correctAnswerRequired: 'Voer het juiste antwoord in',
      updateSuccess: 'Quiz bijgewerkt!',
      saveQuiz: 'Quiz opslaan',
      saving: 'Opslaan...',
      saveSuccess: 'Quiz succesvol opgeslagen',
      saveError: 'Fout bij opslaan'
    },
    live: {
      title: 'Live Quiz',
      host: 'Hosten',
      join: 'Deelnemen',
      waitingRoom: 'Wachtkamer',
      waitingForHost: 'Wachten op host...',
      waitingForPlayers: 'Wachten op spelers...',
      startQuiz: 'Quiz starten',
      playersReady: 'spelers klaar',
      enterName: 'Voer uw naam in',
      enterNamePlaceholder: 'Uw bijnaam',
      joinGame: 'Deelnemen',
      shareLink: 'Deel deze link',
      shareCode: 'of deze code',
      scanQR: 'Scan QR-code',
      preparing: 'Quiz wordt voorbereid...',
      getReady: 'Maak je klaar!',
      questionOf: 'Vraag {{current}} van {{total}}',
      showResults: 'Resultaten tonen',
      showLeaderboard: 'Scorebord tonen',
      showPodium: 'Podium tonen',
      nextQuestionBtn: 'Volgende vraag',
      endQuiz: 'Quiz beëindigen',
      stopQuiz: 'Quiz stoppen',
      forceStop: 'Geforceerd stoppen',
      quizEnded: 'Quiz afgelopen!',
      thanks: 'Bedankt voor het meedoen!',
      yourScore: 'Uw score',
      yourRank: 'Uw rang',
      backToHome: 'Terug naar home',
      noAnswer: 'Geen antwoord',
      answered: 'Beantwoord',
      waiting: 'Wachten...',
      correctPlayers: 'juiste antwoorden',
      avgTime: 'Gemiddelde tijd',
      fastestPlayer: 'Snelste',
      you: 'u',
      noScoresYet: 'Nog geen scores',
      playersCount: '{{count}} speler',
      playersCount_plural: '{{count}} spelers',
      playersConnected: '{{count}} speler verbonden',
      playersConnected_plural: '{{count}} spelers verbonden',
      playingAs: 'U speelt als',
      youAreFirst: 'U bent de eerste!',
      hostAboutToStart: 'De host start de quiz binnenkort',
      orderElements: 'Orden de elementen correct',
      validateOrder: 'Mijn volgorde bevestigen',
      answerCount: '{{count}} antwoord',
      answerCount_plural: '{{count}} antwoorden',
      checkAllCorrect: 'Vink alle juiste antwoorden aan',
      validateAnswer: 'Mijn antwoord bevestigen',
      typeYourAnswer: 'Typ uw antwoord...',
      enterNumber: 'Voer een nummer in...',
      validate: 'Bevestigen',
      answerSent: 'Antwoord verzonden!',
      waitingForTimeEnd: 'Wachten tot de tijd om is...',
      correctAnswerWas: 'Het juiste antwoord was',
      // New keys
      joinLiveQuiz: 'Deelnemen aan live quiz',
      chooseAvatar: 'Kies uw avatar',
      randomEmoji: 'Willekeurige emoji',
      joinWaitingRoom: 'Naar wachtkamer',
      hostMode: 'HOST MODUS',
      players: 'spelers',
      revealAnswers: 'Antwoorden onthullen',
      answersReceived: 'antwoorden ontvangen',
      viewFinalScores: 'Eindscores bekijken',
      finalScores: 'EINDSCORES',
      yourFinalRanking: 'Uw eindklassering',
      sessionNotFound: 'Spelsessie niet gevonden',
      alreadyStarted: 'Deze quiz is al begonnen',
      sessionClosed: 'De sessie is gesloten',
      welcome: 'Welkom bij de quiz!',
      joinError: 'Fout bij deelnemen',
      notFound: 'Quiz niet gevonden',
      notOwner: 'U bent niet de eigenaar van deze quiz',
      noQuestions: 'Deze quiz heeft geen vragen',
      loadError: 'Fout bij laden van quiz',
      startError: 'Fout bij starten',
      nextQuestionError: 'Fout bij volgende vraag',
      confirmStop: 'Weet u zeker dat u de quiz nu wilt stoppen?',
      correct: 'Correct!',
      incorrect: 'Fout',
      points: 'punten',
      podium: {
        title: 'Podium',
        first: '1e',
        second: '2e',
        third: '3e',
        congratulations: 'Gefeliciteerd!',
        bestPlayers: 'De beste spelers van deze quiz!'
      }
    }
  },
  questionnaire: {
    title: 'Vragenlijst titel',
    description: 'Beschrijving',
    questions: 'Vragen',
    question: 'Vraag',
    create: 'Vragenlijst maken',
    edit: 'Vragenlijst bewerken',
    editDescription: 'Bewerk de vragen en vertakkingsvoorwaarden',
    generalInfo: 'Algemene informatie',
    descriptionOptional: 'Beschrijving (optioneel)',
    addQuestion: 'Vraag toevoegen',
    questionText: 'Vraagtekst',
    responseType: 'Antwoordtype',
    responseOptions: 'Antwoordopties',
    addOption: 'Optie toevoegen',
    placeholderLabel: 'Plaatshouder (hulptekst)',
    required: 'Verplichte vraag',
    requiredShort: 'Verplicht',
    conditional: 'Conditioneel',
    conditionalBranching: 'Conditionele vraag (vertakking)',
    defineWhereToGo: 'Bepaal waarheen afhankelijk van het antwoord:',
    ifAnswer: 'Als "{{answer}}" →',
    nextQuestionDefault: 'Volgende vraag (standaard)',
    nextQuestion: 'Volgende vraag',
    byDefault: 'Standaard →',
    endOfQuestionnaire: 'Einde vragenlijst',
    noText: 'Zonder tekst',
    questionWithoutText: 'Vraag zonder tekst',
    noQuestionsAdded: 'Geen vragen toegevoegd',
    addFirstQuestion: 'Eerste vraag toevoegen',
    notFound: 'Vragenlijst niet gevonden',
    noQuestions: 'Deze vragenlijst heeft geen vragen',
    enterName: 'Voer uw naam in',
    startError: 'Fout bij starten',
    invalidEmail: 'Voer een geldig e-mailadres in',
    selectAtLeastOne: 'Selecteer ten minste één optie',
    requiredQuestion: 'Deze vraag is verplicht',
    play: {
      title: 'Vragenlijst',
      description: 'Beantwoord de onderstaande vragen',
      yourName: 'Uw naam',
      enterName: 'Voer uw naam in',
      start: 'Starten',
      questionOf: 'Vraag {{current}} van {{total}}',
      multipleAnswersPossible: 'Meerdere antwoorden mogelijk',
      selectOption: 'Selecteer een optie',
      yourAnswer: 'Uw antwoord',
      yourDetailedAnswer: 'Uw uitgebreide antwoord',
      enterNumber: 'Voer een nummer in',
      previous: 'Vorige',
      next: 'Volgende',
      finish: 'Voltooien',
      thanks: 'Bedankt {{name}}!',
      responsesRecorded: 'Uw antwoorden zijn opgeslagen.',
      summary: 'Samenvatting',
      questionsAnswered: '{{count}} vraag/vragen beantwoord',
      seeDetails: 'Details bekijken',
      backToHome: 'Terug naar home'
    },
    responses: 'Antwoorden',
    totalResponses: 'ontvangen antwoorden',
    noResponses: 'Nog geen antwoorden',
    optional: 'Optionele vraag',
    conditionalLogic: 'Conditionele logica',
    addCondition: 'Voorwaarde toevoegen',
    thenGoTo: 'Ga dan naar',
    questionTypes: {
      singleChoice: 'Enkele keuze',
      multipleChoice: 'Meerkeuze',
      trueFalse: 'Waar/Onwaar',
      dropdown: 'Dropdown',
      shortText: 'Korte tekst',
      longText: 'Lange tekst',
      number: 'Nummer',
      email: 'E-mail',
      date: 'Datum',
      rating: 'Beoordeling',
      yesNo: 'Ja/Nee'
    },
    placeholders: {
      title: 'Bijv.: Tevredenheidsonderzoek',
      description: 'Beschrijf kort uw vragenlijst...',
      questionText: 'Voer uw vraag in...',
      option: 'Optie',
      placeholder: 'Bijv.: Voer uw antwoord in...',
      shortText: 'Uw antwoord...',
      longText: 'Schrijf uw uitgebreide antwoord...',
      number: 'Voer een nummer in',
      email: 'uw@email.com',
      date: 'Selecteer een datum'
    },
    submit: 'Verzenden',
    submitSuccess: 'Bedankt voor uw antwoord!',
    submitError: 'Fout bij verzenden',
    results: {
      title: 'Resultaten',
      summary: 'Samenvatting',
      details: 'Details',
      export: 'Exporteren',
      filter: 'Filteren',
      respondent: 'Respondent',
      date: 'Datum',
      viewResponse: 'Antwoord bekijken'
    },
    playScreen: {
      title: 'Vragenlijst',
      description: 'Beschrijving',
      yourName: 'Uw naam',
      enterName: 'Voer uw naam in',
      start: 'Starten',
      questionOf: 'Vraag {current} van {total}',
      multipleAnswersPossible: 'Meerdere antwoorden mogelijk',
      selectOption: 'Selecteer een optie',
      yourAnswer: 'Uw antwoord',
      yourDetailedAnswer: 'Uw uitgebreide antwoord',
      enterNumber: 'Voer een nummer in',
      previous: 'Vorige',
      next: 'Volgende',
      finish: 'Voltooien',
      thanks: 'Bedankt!',
      responsesRecorded: 'Uw antwoorden zijn opgeslagen.',
      summary: 'Samenvatting',
      questionsAnswered: 'Beantwoorde vragen',
      seeDetails: 'Details bekijken',
      backToHome: 'Terug naar home'
    }
  },
  events: {
    event: 'Evenement',
    ourEvent: 'ons evenement',
    title: 'Evenement titel',
    date: 'Datum',
    location: 'Locatie',
    guests: 'Gasten',
    guest: 'Gast',
    tables: 'Tafels',
    table: 'Tafel',
    seatingPlan: 'Tafelschikking',
    guestbook: 'Gastenboek',
    giftList: 'Cadeaulijst',
    scanner: 'QR Scanner',
    present: 'Aanwezig',
    absent: 'Afwezig',
    addGuest: 'Gast toevoegen',
    exportExcel: 'Excel exporteren',
    totalGuests: 'Totaal gasten',
    edit: {
      managePrograms: 'Programma\'s & menu\'s beheren'
    },
    gifts: {
      title: 'Cadeaulijst',
      addGift: 'Cadeau toevoegen',
      giftName: 'Cadeaunaam',
      giftPrice: 'Prijs',
      available: 'Beschikbaar',
      reserved: 'Gereserveerd',
      purchased: 'Gekocht',
      reserveGift: 'Dit cadeau reserveren',
      noGifts: 'Geen cadeaus in de lijst',
      giftType: 'Cadeautype',
      typeArticle: 'Artikel',
      typeArticleDesc: 'Een klassiek artikel om te geven',
      typeMoney: 'Geld',
      typeMoneyDesc: 'Vrije financiële bijdrage',
      typeShared: 'Gedeeld artikel',
      typeSharedDesc: 'Artikel waarvan de prijs wordt gedeeld',
      targetAmount: 'Doelbedrag (€)',
      yourContribution: 'Uw bijdrage (€)',
      contributionPlaceholder: 'Voer een bedrag in',
      amountRequired: 'Voer een bedrag in',
      contributionSuccess: 'Bedankt {{name}}! 🎉 Uw bijdrage van {{amount}}€ is opgeslagen.',
      remainingAmount: 'Resterend bedrag',
      goalReached: 'Doel bereikt! 🎉',
      progressLabel: 'Voortgang',
      contributorsCount: '{{count}} bijdrager(s)',
      enterValidAmount: 'Voer een geldig bedrag in',
      privateContribution: 'Uw bijdrage is privé en alleen zichtbaar voor u en de organisator',
      sendMoney: 'Geld sturen',
      paymentLink: 'Betaallink (bank, PayPal, Lydia...)',
      paymentLinkDesc: 'Gasten kunnen klikken om direct geld te sturen',
      reservationsPossible: '{{count}} reservering(en) mogelijk',
      contributionUpdated: 'Uw bijdrage is bijgewerkt.',
      reservedBy: 'Gereserveerd door'
    },
    view: {
      registerToAccess: 'Registreer om toegang te krijgen tot de cadeaulijst en activiteiten',
      fillNameRequired: 'Vul uw voor- en achternaam in',
      selectRelation: 'Selecteer uw relatie met de organisatoren',
      fillSpouseRequired: 'Vul de informatie van uw partner in',
      registrationError: 'Fout bij registratie. Probeer het opnieuw.',
      registrationNote: 'Uw registratie zal door de host worden bevestigd',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      firstNamePlaceholder: 'Uw voornaam',
      lastNamePlaceholder: 'Uw achternaam',
      gender: 'Geslacht',
      male: 'Man',
      female: 'Vrouw',
      relationWithOrganizer: 'Relatie met de organisatoren',
      invitationType: 'Type uitnodiging',
      singleInvitation: 'Alleen',
      coupleInvitation: 'Met partner',
      spouseInfo: 'Informatie partner',
      spouseFirstName: 'Voornaam partner',
      spouseLastName: 'Achternaam partner',
      spouseGender: 'Geslacht partner',
      ourGallery: 'Onze galerij',
      photosAutoScroll: '{{count}} foto\'s - automatisch scrollen',
      photoOf: 'Foto {{current}} van {{total}}',
      chooseGiftToOffer: 'Kies een cadeau om te geven',
      listEmpty: 'De lijst is leeg',
      noGiftsYet: 'Er zijn nog geen cadeaus',
      iOfferIt: 'Ik bied het aan',
      enterYourName: 'Vul uw naam in',
      yourName: 'Uw naam',
      stayAnonymous: 'Anoniem blijven',
      onlyOrganizerSees: 'Alleen u en de organisator zien uw naam; anderen zien “anoniem”',
      you: 'u',
      anonymousSelfNote: 'Alleen u en de organisator zien uw naam. Anderen zien “anoniem”.',
      messageOptional: 'Bericht (optioneel)',
      messagePlaceholder: 'Een klein berichtje...',
      visibleToOrganizerOnly: 'Alleen zichtbaar voor de organisator',
      reserveThisGift: 'Dit cadeau reserveren',
      reserving: 'Reserveren...',
      reservationSuccess: '{{name}}, uw reservering is geregistreerd!',
      reservationError: 'Fout bij reservering',
      ourStory: 'Ons verhaal',
      discoverGiftList: 'Ontdek de cadeaulijst',
      yourPersonalizedInvitation: 'Uw gepersonaliseerde uitnodiging',
      downloadPdfWithName: 'Download uw uitnodiging als PDF',
      generating: 'Genereren...',
      downloadAgain: 'Opnieuw downloaden',
      downloadMyInvitation: 'Mijn uitnodiging downloaden',
      invitationDownloadedSuccess: 'Uitnodiging succesvol gedownload!',
      linkCopied: 'Link gekopieerd!',
      on: 'op',
      loadingEvent: 'Evenement laden...',
      oops: 'Oeps!',
      notFound: 'Evenement niet gevonden',
      loadError: 'Fout bij het laden',
      howManyReserve: 'Hoeveel wilt u reserveren?',
      outOf: 'van',
      available: 'beschikbaar',
      onlyRemainingReservations: 'Er zijn nog maar {{count}} reserveringen over'
    },
    create: {
      title: 'Evenement maken',
      editTitle: 'Evenement bewerken',
      eventName: 'Evenementnaam',
      eventDate: 'Evenementdatum',
      eventLocation: 'Locatie',
      saveEvent: 'Evenement opslaan',
      showInvitationTicket: 'Uitnodigingsticket tonen',
      showInvitationTicketDesc: 'Gasten kunnen hun gepersonaliseerde uitnodiging als PDF downloaden',
      hideInvitationTicket: 'Uitnodigingsticket verbergen',
      hideInvitationTicketDesc: 'Gasten zien de uitnodigingsdownloadsectie niet',
      backgroundMusic: 'Achtergrondmuziek',
      backgroundMusicDesc: 'Muziek die op de verhaal-/galerij pagina speelt',
      uploadMusic: 'Muziekbestand uploaden',
      musicFormats: 'MP3, M4A, WAV, OGG (max 10MB)',
      removeMusic: 'Muziek verwijderen',
      musicPlaying: 'Muziek speelt',
      musicPaused: 'Muziek gepauzeerd'
    }
  },
  guestbook: {
    title: 'Gastenboek',
    theGuestbook: 'Het Gastenboek',
    leaveMessage: 'Bericht achterlaten',
    leaveNote: 'Laat een berichtje achter',
    leaveNoteDesc: 'Deel uw wensen, een anekdote of een foto-herinnering om dit moment met ons te vieren.',
    leaveEternalMemory: 'Laat een eeuwige herinnering achter',
    leaveEternalMemoryDesc: 'Vereeuwigt uw aanwezigheid met een 3D-bericht voor het bruidspaar.',
    yourName: 'Uw naam',
    yourMessage: 'Uw bericht',
    writeMemorable: 'Schrijf iets gedenkwaardigs...',
    characters: 'tekens',
    photoMemory: 'Foto-herinnering',
    photoFormats: 'JPG, PNG (max 5MB)',
    addPhoto: 'Foto toevoegen',
    send: 'Verzenden',
    sign: 'Ondertekenen',
    signBook: 'Gastenboek ondertekenen',
    signTheBook: 'Boek ondertekenen',
    readBook: 'Boek lezen',
    messages: 'Berichten',
    noMessages: 'Nog geen berichten',
    noMessagesYet: 'Nog geen berichten...',
    beFirst: 'Wees de eerste om te ondertekenen!',
    deleteMessage: 'Dit bericht verwijderen',
    deleteConfirm: 'Weet u zeker dat u dit bericht wilt verwijderen?',
    messageDeleted: 'Bericht verwijderd',
    from: 'Van:',
    withLove: '– Met al onze liefde ❤️',
    memories: 'Herinneringen...',
    pageOf: 'PAGINA {{current}} VAN {{total}}',
    latestMessages: 'Laatste berichten',
    photoShared: '📷 Foto gedeeld',
    experience3d: '3D-ervaring',
    howItWorks: 'Hoe werkt het?',
    takePhoto: 'Maak een foto',
    writeWord: 'Schrijf een berichtje',
    imageTooLarge: 'Afbeelding te groot (max 5 MB)',
    invalidFile: 'Ongeldig bestand',
    enterName: 'Voer uw naam in',
    addMessageOrPhoto: 'Voeg een bericht of foto toe',
    messageAdded: 'Bericht toegevoegd! 💕',
    sendError: 'Fout bij verzenden',
    minutesAgo: '{{count}} min geleden',
    hoursAgo: '{{count}}u geleden',
    daysAgo: '{{count}}d geleden',
    noMessagesToExport: 'Geen berichten om te exporteren',
    generatingPdf: 'PDF wordt gegenereerd...',
    generatedOn: 'Gegenereerd op',
    messagesCount: 'bericht(en)',
    pdfDownloaded: 'PDF gedownload!',
    pdfError: 'Fout bij genereren van PDF',
    shareLink: 'Link delen',
    downloadPdf: 'PDF downloaden',
    linkShared: 'Link gedeeld!',
    linkCopied: 'Link gekopieerd naar klembord!',
    copyError: 'Kan link niet kopiëren',
    shareText: 'Laat een bericht achter in het gastenboek van {{eventName}}! 💌',
    anonymous: 'Anoniem',
    messagesPublic: 'Berichten zichtbaar voor iedereen',
    messagesPrivate: 'Berichten alleen zichtbaar voor u',
    messagesPublicDesc: 'Gasten kunnen berichten van anderen lezen',
    messagesPrivateDesc: 'Gasten kunnen alleen schrijven, alleen u kunt lezen'
  },

  // Guests
  guests: {
    title: 'Gastenlijst',
    addGuest: 'Gast toevoegen',
    editGuest: 'Gast bewerken',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    gender: 'Geslacht',
    male: 'Man',
    female: 'Vrouw',
    ticketType: 'Tickettype',
    single: 'Enkel',
    couple: 'Koppel',
    spouseInfo: 'Partnerinformatie',
    relation: 'Relatie met organisator',
    selectRelation: '-- Selecteren --',
    table: 'Tafel',
    tableOptional: 'Tafel (optioneel)',
    notAssigned: '-- Niet toegewezen --',
    cancel: 'Annuleren',
    addTheGuest: 'Gast toevoegen',
    saveChanges: 'Opslaan',
    totalGuests: 'Totaal gasten',
    tickets: 'Tickets',
    present: 'Aanwezig',
    absent: 'Afwezig',
    presents: 'Aanwezig',
    absents: 'Afwezig',
    searchGuest: 'Gast zoeken...',
    allStatuses: 'Alle statussen',
    allTickets: 'Alle tickets',
    noGuests: 'Nog geen gasten',
    noMatchingGuests: 'Geen gast komt overeen met uw zoekopdracht',
    addFirstGuest: 'Eerste gast toevoegen',
    guest: 'Gast',
    type: 'Type',
    statusClick: 'Status (klik om te wijzigen)',
    actions: 'Acties',
    downloadPdf: 'PDF downloaden',
    edit: 'Bewerken',
    deleteGuest: 'Verwijderen',
    yourInvitation: 'Uw Uitnodigingsticket',
    coupleTicket: 'Koppel-ticket met',
    scanQrCode: 'Scan deze QR-code bij de ingang',
    personalTicket: 'Dit ticket is persoonlijk en niet overdraagbaar',
    sortNameAsc: 'Naam (A → Z)',
    sortNameDesc: 'Naam (Z → A)',
    sortFirstNameAsc: 'Voornaam (A → Z)',
    sortFirstNameDesc: 'Voornaam (Z → A)',
    sortDateRecent: 'Meest recent',
    sortDateOldest: 'Oudste',
    sortByTable: 'Op tafel',
    sortByRelation: 'Op relatie',
    sortPresentFirst: 'Aanwezig eerst',
    sortAbsentFirst: 'Afwezig eerst',
    tables: 'Tafels',
    scanner: 'Scanner',
    plan: 'Plan',
    guestbook: 'Gastenboek',
    excel: 'Excel',
    add: 'Toevoegen',
    // Pending guests
    pendingApproval: 'In afwachting van goedkeuring',
    pendingRequests: 'Wachtende aanvragen',
    confirmedList: 'Bevestigde lijst',
    noPendingRequests: 'Geen wachtende aanvragen',
    noPendingDescription: 'Nieuwe gasten die zich via de evenementpagina registreren verschijnen hier',
    pendingInfo: 'Deze gasten hebben zich via de link van uw evenement geregistreerd en wachten op uw goedkeuring',
    requestedOn: 'Aangevraagd op',
    approve: 'Goedkeuren',
    reject: 'Weigeren',
    pendingApproved: 'Gast goedgekeurd en toegevoegd aan de lijst',
    pendingRejected: 'Aanvraag geweigerd',
    approveError: 'Fout bij goedkeuren van de gast',
    rejectError: 'Fout bij weigeren van de aanvraag'
  },

  settings: {
    title: 'Accountinstellingen',
    description: 'Beheer uw persoonlijke informatie',
    profile: 'Profiel',
    language: 'Taal',
    theme: 'Thema',
    notifications: 'Meldingen',
    security: 'Beveiliging',
    changePassword: 'Wachtwoord wijzigen',
    deleteAccount: 'Account verwijderen',
    currentInfo: 'Huidige informatie',
    displayName: 'Weergavenaam',
    currentEmail: 'Huidige e-mail',
    notDefined: 'Niet gedefinieerd',
    preferences: 'Voorkeuren',
    tutorial: 'Tutorial',
    restartTutorial: 'Tutorial herstarten',
    saveChanges: 'Wijzigingen opslaan',
    email: {
      changeEmail: 'E-mail wijzigen',
      newEmail: 'Nieuwe e-mail',
      confirmNewEmail: 'Bevestig nieuwe e-mail',
      currentPassword: 'Huidig wachtwoord (ter bevestiging)',
      passwordHelp: 'Voer uw huidige wachtwoord in om de wijziging te bevestigen',
      updateEmail: 'E-mail bijwerken',
      updating: 'Bijwerken...',
      fillAllFields: 'Vul alle velden in',
      emailsMismatch: 'E-mails komen niet overeen',
      sameEmail: 'De nieuwe e-mail is hetzelfde als de huidige',
      invalidFormat: 'Ongeldig e-mailformaat',
      verificationSent: '📧 Er is een verificatie-e-mail verzonden naar {{email}}. Klik op de link om de wijziging te bevestigen.',
      verificationSentTitle: 'Verificatie-e-mail verzonden!',
      verificationSentDesc: 'Controleer uw inbox en klik op de link om te bevestigen',
      wrongPassword: 'Onjuist wachtwoord',
      emailInUse: 'Dit e-mailadres wordt al gebruikt door een ander account',
      sessionExpired: 'Sessie verlopen. Log opnieuw in.',
      operationNotAllowed: 'Bewerking niet toegestaan. Controleer de Firebase-instellingen.',
      updateError: 'Fout bij het bijwerken',
      howItWorks: 'Hoe werkt het?',
      step1: '1. Voer uw nieuwe e-mail en huidige wachtwoord in',
      step2: '2. Er wordt een verificatie-e-mail naar het nieuwe adres verzonden',
      step3: '3. Klik op de link in de e-mail om de wijziging te bevestigen',
      important: 'Belangrijk',
      importantDesc: 'Als u uw e-mail wijzigt, verandert de identificatie waarmee u inlogt. U moet de nieuwe e-mail gebruiken bij uw volgende aanmelding.'
    }
  },
  admin: {
    title: 'Administratie',
    users: 'Gebruikers',
    userManagement: 'Gebruikersbeheer',
    pendingUsers: 'Wachtende gebruikers',
    validatedUsers: 'Gevalideerde gebruikers',
    validateUser: 'Gebruiker valideren',
    deleteUser: 'Gebruiker verwijderen',
    quizMusic: {
      title: 'Quiz Muziek',
      description: 'Beheer muziek tijdens quizzen',
      lobby: 'Wachtmuziek',
      effects: 'Geluidseffecten',
      gameplay: 'Spelmuziek',
      upload: 'Uploaden',
      delete: 'Verwijderen',
      play: 'Afspelen',
      noMusic: 'Geen muziek'
    }
  },
  errors: {
    general: 'Er is een fout opgetreden',
    notFound: 'Pagina niet gevonden',
    unauthorized: 'Geen toegang',
    tryAgain: 'Probeer het opnieuw'
  },
  validation: {
    required: 'Dit veld is verplicht',
    email: 'Ongeldige e-mail',
    minLength: 'Minimaal {{min}} tekens',
    passwordMatch: 'Wachtwoorden komen niet overeen'
  },
  time: {
    justNow: 'Zojuist',
    seconds: 'seconden',
    minutes: 'minuten',
    hours: 'uren',
    days: 'dagen',
    ago: 'geleden',
    today: 'Vandaag',
    yesterday: 'Gisteren'
  },

  // Relations
  relations: {
    fatherGroom: 'Vader van de bruidegom',
    motherGroom: 'Moeder van de bruidegom',
    brotherGroom: 'Broer van de bruidegom',
    sisterGroom: 'Zus van de bruidegom',
    fatherBride: 'Vader van de bruid',
    motherBride: 'Moeder van de bruid',
    brotherBride: 'Broer van de bruid',
    sisterBride: 'Zus van de bruid',
    grandparent: 'Grootouder',
    uncle: 'Oom',
    aunt: 'Tante',
    cousin: 'Neef/Nicht',
    nephew: 'Neef/Nicht',
    childhoodFriend: 'Jeugdvriend(in)',
    closeFriend: 'Goede vriend(in)',
    colleague: 'Collega',
    neighbor: 'Buur',
    witness: 'Getuige',
    bridesmaid: 'Bruidsmeisje',
    groomsman: 'Bruidsjonker',
    otherFamily: 'Andere familie',
    otherFriend: 'Andere vriend',
    professional: 'Professional',
    other: 'Anders'
  },

  // Event Types
  eventTypes: {
    wedding: 'Bruiloft',
    birthday: 'Verjaardag',
    birth: 'Geboorte',
    baptism: 'Doop',
    housewarming: 'Housewarming',
    christmas: 'Kerst',
    other: 'Evenement'
  },

  // Event Responses / Statistics
  eventResponses: {
    title: 'Statistieken',
    backToDashboard: 'Terug naar dashboard',
    stats: {
      giftsReserved: 'Gereserveerde cadeaus',
      participants: 'Deelnemers',
      reservations: 'Reserveringen',
      reservedValue: 'Gereserveerde waarde'
    },
    progress: 'Voortgang',
    reservationsList: 'Reserveringslijst',
    giftSummary: 'Cadeauoverzicht',
    anonymous: 'anoniem',
    giftDeleted: 'Cadeau verwijderd',
    deleteReservation: 'Reservering verwijderen',
    noReservations: 'Nog geen reserveringen',
    shareToReceive: 'Deel uw lijst om reserveringen te ontvangen',
    reservation: 'reservering',
    notReserved: 'Niet gereserveerd',
    reserved: 'Gereserveerd',
    available: 'Beschikbaar',
    confirmDelete: 'Deze reservering verwijderen?',
    deleteSuccess: 'Reservering verwijderd',
    errors: {
      notFound: 'Evenement niet gevonden',
      unauthorized: 'U bent niet gemachtigd om deze statistieken te bekijken',
      loadError: 'Fout bij laden van gegevens',
      deleteError: 'Fout bij verwijderen'
    }
  },

  // Profile
  profile: {
    title: 'Mijn Profiel',
    subtitle: 'Beheer uw persoonlijke informatie',
    personalInfo: 'Persoonlijke informatie',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    email: 'E-mail',
    phone: 'Telefoon',
    bio: 'Biografie',
    bioPlaceholder: 'Vertel ons over uzelf...',
    address: 'Adres',
    streetName: 'Straat',
    streetNumber: 'Nr.',
    postalCode: 'Postcode',
    city: 'Stad',
    country: 'Land',
    photoUpdated: 'Profielfoto bijgewerkt',
    photoError: 'Fout bij uploaden van foto',
    photoDeleted: 'Profielfoto verwijderd',
    deletePhoto: 'Verwijderen',
    deletePhotoError: 'Fout bij verwijderen van foto',
    invalidImageType: 'Selecteer een afbeelding',
    imageTooLarge: 'Afbeelding mag niet groter zijn dan 5MB',
    updated: 'Profiel succesvol bijgewerkt',
    updateError: 'Fout bij bijwerken van profiel',
    upgradeToPro: 'Upgrade naar Pro',
    managePlan: 'Mijn abonnement beheren',
    unlockFeatures: 'Ontgrendel alle functies en onbeperkte deelnemers',
    currentPlan: 'Uw huidige plan: {{plan}}',
    renewsIn: 'Verlenging over {{days}} dagen',
    endsIn: 'Eindigt over {{days}} dagen',
    manageSubscription: 'Beheren / Annuleren',
    seePlans: 'Plannen bekijken',
    changePlan: 'Wijzigen',
    subscriptionSettings: 'Abonnementsinstellingen',
    managePayments: 'Betalingen en facturering beheren',
    viewPlans: 'Plannen bekijken',
    comparePlans: 'Beschikbare aanbiedingen vergelijken',
    logoutDesc: 'Uitloggen van uw account',
    legalInfo: 'Juridische informatie',
    dangerZone: 'Gevarenzone',
    deleteAccountWarning: 'Accountverwijdering is onomkeerbaar. Al uw gegevens worden permanent verwijderd.',
    deleteAccount: 'Mijn account verwijderen',
    confirmDeletion: 'Verwijdering bevestigen',
    actionIrreversible: 'Deze actie is onomkeerbaar',
    importantNotice: 'Belangrijke mededeling',
    deleteWarning1: 'Al uw quizzen, vragenlijsten en evenementen worden verwijderd',
    deleteWarning2: 'Uw persoonlijke gegevens worden permanent gewist',
    deleteWarning3: 'U kunt niet meer toegang krijgen tot uw account',
    deleteWarning4: 'Als uw abonnement binnen 48 uur wordt verlengd en u de verlenging niet hebt geannuleerd, wordt de laatste afschrijving vóór verwijdering verwerkt.',
    typeConfirm: 'Typ "VERWIJDEREN" ter bevestiging:',
    typeSupprimer: 'Typ "VERWIJDEREN" ter bevestiging',
    accountMarkedDeleted: 'Account gemarkeerd voor verwijdering. De laatste afschrijving wordt verwerkt.',
    accountDeleted: 'Account succesvol verwijderd',
    deleteError: 'Fout bij verwijderen van account',
    confirmDelete: 'Permanent verwijderen',
    adminGrantedAccess: 'Toegang verleend door beheerder',
    adminGrantedAccessDesc: 'U hebt volledige toegang verleend door de beheerder.',
    revokeAccess: 'Deze toegang intrekken',
    revokeAccessConfirm: 'Mijn toegang intrekken',
    revokeAccessDesc: 'Deze actie verwijdert uw verleende toegang. U keert terug naar het gratis plan.'
  },

  // Admin
  admin: {
    tabs: {
      services: 'Services',
      messaging: 'Berichten'
    },
    messaging: {
      title: 'Een bericht sturen',
      subtitle: 'Schrijf naar één, meerdere of alle gebruikers. Het bericht wordt per e-mail en melding bezorgd.',
      allUsers: 'Alle gebruikers',
      selectUsers: 'Gebruikers selecteren',
      searchUser: 'Een gebruiker zoeken...',
      toggleAll: 'Alles (de)selecteren',
      noUsers: 'Geen gebruiker',
      subject: 'Onderwerp',
      subjectPlaceholder: 'Onderwerp van uw bericht',
      message: 'Bericht',
      messagePlaceholder: 'Schrijf hier uw bericht...',
      emailHint: 'De e-mail krijgt het HugoQuiz-ontwerp met een knop naar de site.',
      send: 'Bericht verzenden',
      sending: 'Bezig met verzenden...',
      needSubject: 'Voer een onderwerp in.',
      needMessage: 'Voer een bericht in.',
      needRecipients: 'Selecteer minstens één ontvanger.',
      confirm: 'Dit bericht naar {{count}} gebruiker(s) sturen?',
      sent: 'Bericht verzonden naar {{sent}}/{{total}} gebruiker(s).'
    },
    services: {
      verifications: 'Verificaties',
      servicesList: 'Services',
      reviews: 'Beoordelingen',
      noReviews: 'Geen beoordelingen die op validatie wachten.',
      reviewApproved: 'Beoordeling gepubliceerd',
      reviewRejected: 'Beoordeling afgewezen',
      noVerifications: 'Geen openstaande verificatieverzoeken.',
      noServices: 'Geen services.',
      idDocument: 'Identiteitsbewijs',
      openPdf: 'PDF openen',
      selfieVideo: 'Selfievideo',
      approve: 'Goedkeuren',
      reject: 'Afwijzen',
      publish: 'Publiceren',
      restrict: 'Beperken',
      preview: 'Bekijken',
      verifApproved: 'Identiteit goedgekeurd',
      verifRejected: 'Verzoek afgewezen',
      serviceApproved: 'Service gepubliceerd',
      serviceUpdated: 'Service bijgewerkt',
      serviceDeleted: 'Service verwijderd',
      messagePlaceholder: 'Bericht met de reden (verzonden naar de gebruiker)',
      statusPending: 'In afwachting',
      statusApproved: 'Gepubliceerd',
      statusRejected: 'Afgewezen',
      statusRestricted: 'Beperkt',
      seedHint: 'Maak twee demo-services (Hugographie — fotograaf/videograaf en Hugo — eventplanner) gekoppeld aan uw adminaccount.',
      seedButton: 'Demo-services maken',
      seedConfirm: 'De demo-services Hugographie en Hugo op uw adminaccount maken?',
      seedDone: 'Demo-services gemaakt en gepubliceerd!',
      rejectVerifTitle: 'Verificatieverzoek afwijzen',
      rejectServiceTitle: 'Deze service afwijzen',
      restrictTitle: 'De weergave van deze service beperken',
      deleteTitle: 'Deze service definitief verwijderen',
      filter: { all: 'Alle', pending: 'In afwachting', approved: 'Gepubliceerd', rejected: 'Afgewezen', restricted: 'Beperkt' }
    },
    chat: {
      title: 'Chatbeheer',
      subtitle: 'Antwoord wachtende gebruikers',
      description: 'Antwoord gebruikers die menselijke hulp nodig hebben.',
      manage: 'Chats beheren',
      waiting: 'Wachtend',
      active: 'Actief',
      waitingTag: 'Wachtend',
      humanMode: 'Mens',
      noConversations: 'Geen gesprekken',
      selectConversation: 'Selecteer een gesprek',
      selectHint: 'Klik links op een gesprek om te beginnen',
      placeholder: 'Typ uw antwoord...',
      returnToBot: 'Terug naar bot',
      close: 'Sluiten',
      confirmClose: 'Weet u zeker dat u dit gesprek wilt sluiten?',
      confirmReturnToBot: 'Wilt u de controle teruggeven aan de bot?',
      conversationClosed: 'Gesprek gesloten',
      returnedToBot: 'Teruggegeven aan bot',
      botModeWarning: 'Dit gesprek wordt beheerd door de bot.',
      takeOver: 'Overnemen'
    }
  },

  // Chatbot
  chatbot: {
    title: 'HugoQuiz-assistent',
    placeholder: 'Stel uw vraag...',
    greeting: 'Hallo! Hoe kan ik u helpen?',
    talkToHuman: 'Praat met team',
    waitingForTeam: 'Wachten op team...',
    teamResponding: 'HugoQuiz-team',
    online: 'Online',
    conversationEnded: 'Gesprek beëindigd'
  },

  // Tutorial
  tutorial: {
    welcome: 'Welkom bij HugoQuiz!',
    welcomeDesc: 'Laat ons u door alle functies leiden.',
    start: 'Tutorial starten',
    skip: 'Overslaan',
    next: 'Volgende',
    prev: 'Vorige',
    finish: 'Voltooien',
    step: 'Stap',
    of: 'van',
    steps: {
      dashboard: {
        title: 'Uw dashboard',
        content: 'Hier vindt u al uw quizzen, vragenlijsten en evenementen.'
      },
      createQuiz: {
        title: 'Quiz maken',
        content: 'Klik hier om een nieuwe interactieve quiz te maken met vragen en een timer.'
      },
      createEvent: {
        title: 'Evenement maken',
        content: 'Beheer bruiloften, verjaardagen en feesten met gastenlijsten, QR-codes en tafelschema\'s.'
      },
      settings: {
        title: 'Instellingen',
        content: 'Pas uw profiel aan, verander de taal en beheer uw voorkeuren.'
      },
      chatbot: {
        title: 'Hulp nodig?',
        content: 'Onze slimme assistent is er altijd om uw vragen te beantwoorden!'
      }
    }
  },

  // Subscription & Pricing
  subscription: {
    title: 'Abonnement',
    mySubscription: 'Mijn abonnement',
    choosePlan: 'Kies uw plan',
    subtitle: 'Krachtige tools voor interactieve quizzen en evenementen',
    month: 'maand',
    year: 'jaar',
    monthly: 'Maandelijks',
    yearly: 'Jaarlijks',
    savePercent: 'Bespaar {{percent}}%',
    currentPlan: 'Huidig plan',
    popular: 'Populair',
    bestValue: 'Beste waarde',
    select: 'Kies dit plan',
    upgrade: 'Upgraden',
    downgrade: 'Downgraden',
    manage: 'Beheren',
    
    plans: {
      free: 'Gratis',
      freeDesc: 'Om het platform te ontdekken',
      quizQuestionnaire: 'Quiz & Vragenlijsten',
      quizQuestionnaireDesc: 'Voor contentmakers',
      events: 'Evenementen',
      eventsDesc: 'Voor evenementorganisatoren',
      complete: 'Compleet',
      completeDesc: 'Toegang tot alle functies',
      adminGranted: 'Toegewezen toegang',
      quizMonthly: 'Quiz & Vragenlijst - Maandelijks',
      eventsMonthly: 'Evenementen - Maandelijks',
      completeMonthly: 'Compleet - Maandelijks',
      quizYearly: 'Quiz & Vragenlijst - Jaarlijks',
      eventsYearly: 'Evenementen - Jaarlijks',
      completeYearly: 'Compleet - Jaarlijks'
    },

    // Admin granted access
    adminGranted: {
      title: 'Toegang verleend door beheerder',
      description: 'U profiteert van gratis toegang verleend door een beheerder. Deze toegang kan op elk moment worden ingetrokken.',
      renounceTitle: 'Afstand doen van deze toegang',
      renounceDesc: 'Als u deze toegang niet meer nodig hebt, kunt u er afstand van doen en terugkeren naar het gratis plan.',
      renounceBtn: 'Afstand doen van mijn toegang'
    },

    features: {
      quiz: 'Interactieve quizzen',
      questionnaire: 'Vragenlijsten',
      events: 'Evenementen',
      participants: '{{count}} deelnemers max',
      participantsUnlimited: 'Onbeperkte deelnemers',
      liveMode: 'Live modus',
      analytics: 'Gedetailleerde analyses',
      export: 'Data export',
      support: 'Prioritaire ondersteuning'
    },

    status: {
      active: 'Actief',
      expiringSoon: 'Verloopt binnenkort',
      expired: 'Verlopen',
      free: 'Gratis',
      cancelled: 'Geannuleerd',
      past_due: 'Betaling in afwachting',
      payment_failed: 'Betaling mislukt'
    },

    expiresIn: 'Verloopt over {{days}} dagen',
    expiringSoonWarning: 'Uw abonnement verloopt binnenkort',
    expiringSoonDesc: 'Verleng om toegang tot uw gegevens te behouden.',
    expiredWarning: 'Uw abonnement is verlopen',
    expiredDesc: 'Uw vragenlijsten en evenementen worden over 30 dagen verwijderd als u niet verlengt.',
    paymentFailedWarning: 'Betaling mislukt',
    paymentFailedDesc: 'We konden uw betaling niet verwerken. Werk uw betalingsgegevens bij om uw abonnement te behouden.',
    pastDueWarning: 'Betaling in afwachting - Respijtperiode',
    pastDueDesc: 'Uw betaling is mislukt maar u heeft een respijtperiode van 7 dagen. Werk uw betaalmethode bij om opschorting te voorkomen.',
    gracePeriodEnds: 'Respijtperiode eindigt over {{days}} dagen',
    updatePaymentMethod: 'Betaalmethode bijwerken',
    paymentRecovered: 'Betaling geslaagd! Uw abonnement is weer actief.',
    upgradeToPro: 'Upgrade naar Pro',
    managePayment: 'Betaling beheren',
    changePlan: 'Plan wijzigen',
    cancelSubscription: 'Abonnement annuleren',

    // Annulering
    cancellation: {
      title: 'Annulering',
      willNotRenew: 'Uw abonnement wordt niet verlengd',
      activeUntil: 'Het blijft actief tot het einde van de huidige periode.',
      reactivate: 'Verlenging heractiveren',
      refundAvailable: 'Terugbetaling beschikbaar',
      refundTimeLeft: 'U heeft nog {{minutes}} minuten om een volledige terugbetaling aan te vragen.',
      requestRefund: 'Terugbetaling aanvragen',
      cancelRenewal: 'Verlenging annuleren',
      cancelRenewalDesc: 'Uw abonnement blijft actief tot het einde van de periode. Er wordt geen terugbetaling gedaan.',
      cancelRenewalBtn: 'Niet verlengen',
      confirmRefund: 'Terugbetaling bevestigen',
      confirmCancel: 'Annulering bevestigen',
      terminateTitle: 'Mijn abonnement beëindigen',
      terminateDesc: 'De beëindiging is onmiddellijk: u verliest direct de voordelen van het abonnement en terugbetaling is niet mogelijk.',
      terminateBtn: 'Onmiddellijk beëindigen',
      terminateConfirmTitle: 'Abonnement beëindigen?',
      terminateWarn1: 'Het verlies van de abonnementsvoordelen is onmiddellijk.',
      terminateWarn2: 'Terugbetaling is niet mogelijk, conform de gebruiksvoorwaarden.',
      terminateWarn3: 'U keert onmiddellijk terug naar het gratis abonnement.',
      errorTerminate: 'Fout bij het beëindigen'
    },

    redirectingToStripe: 'Doorsturen naar Stripe...',
    successTitle: 'Betaling geslaagd! 🎉',
    successMessage: 'Uw abonnement is nu actief. Geniet van alle functies!',
    cancelTitle: 'Betaling geannuleerd',
    cancelMessage: 'U kunt het op elk moment opnieuw proberen.',
    goToDashboard: 'Naar dashboard',
    tryAgain: 'Opnieuw proberen',

    errorCreatingCheckout: 'Fout bij het maken van checkout-sessie',
    errorOpeningPortal: 'Fout bij het openen van beheerportaal',
    
    // Guarantees
    guarantee: {
      cancel: 'Op elk moment opzegbaar',
      secure: 'Veilige betaling',
      support: 'Ondersteuning inbegrepen'
    },
    
    // Subscription management
    manageExisting: 'Mijn bestaande abonnement beheren of annuleren',
    perMonth: 'per maand',
    perYear: 'per jaar',
    save: 'Bespaar',
    subscribe: 'Abonneren',
    currentPlanBadge: 'Uw huidige plan',
    unlimitedQuiz: 'Onbeperkte quizzen',
    noQuiz: 'Quizzen niet inbegrepen',
    unlimitedQuestionnaire: 'Onbeperkte vragenlijsten',
    noQuestionnaire: 'Vragenlijsten niet inbegrepen',
    unlimitedEvents: 'Onbeperkte evenementen',
    noEvents: 'Evenementen niet inbegrepen',
    unlimitedParticipants: 'Onbeperkte deelnemers',
    startTrial: '7 dagen gratis proberen',
    trialNotEligible: 'U komt niet in aanmerking voor de gratis proefperiode',
    
    // Trial
    trial: {
      banner: '7 dagen gratis proberen!',
      bannerDesc: 'Test alle functies zonder verplichtingen. Op elk moment opzegbaar.',
      cardRequired: 'Creditcard vereist',
      alreadyUsed: 'U heeft uw gratis proefperiode al gebruikt.',
      adminGranted: 'De gratis proefperiode is niet beschikbaar voor accounts die gratis toegang hebben gekregen.',
      notEligible: 'U komt niet in aanmerking voor de gratis proefperiode.',
      modalTitle: '7 dagen gratis proefperiode',
      benefit1: 'Volledige toegang tot alle functies gedurende 7 dagen',
      benefit2: 'Op elk moment opzegbaar vóór het einde van de proefperiode',
      warning: 'Creditcard vereist. Automatische afschrijving van €{{price}}/maand op dag 8 indien niet opgezegd.',
      uniqueOffer: 'De gratis proefperiode is slechts één keer per gebruiker beschikbaar, ongeacht het gekozen abonnement.',
      confirm: 'Proefperiode starten',
      active: 'Gratis proefperiode actief',
      endsIn: 'Eindigt over {{days}} dagen',
      endsToday: 'Eindigt vandaag',
      chargeDate: 'Eerste afschrijving gepland op {{date}}',
      endsOn: 'Proefperiode eindigt op {{date}}',
      cancelAnytime: 'Op elk moment gratis opzegbaar',
      cancelBtn: 'Gratis proefperiode opzeggen',
      confirmCancel: 'Weet u zeker dat u uw gratis proefperiode wilt opzeggen? U keert terug naar het gratis abonnement en kunt geen nieuwe proefperiode meer gebruiken.',
      errorCancel: 'Fout bij het opzeggen van de proefperiode'
    },
    
    freeFeatures: {
      quiz: 'Quiz (max. 5 deelnemers)',
      questionnaire: 'Vragenlijsten',
      events: 'Evenementen'
    }
  },

  pricing: {
    title: 'Prijzen',
    heroTitle: 'Plannen op maat van uw behoeften',
    heroSubtitle: 'Begin gratis, schaal naar behoefte',
    faq: 'Veelgestelde vragen',
    allFeaturesIncluded: 'Alle functies inbegrepen',
    perMonth: '/maand',
    perYear: '/jaar',
    startFree: 'Gratis beginnen',
    getStarted: 'Aan de slag'
  },

  // Seating Plan
  seatingPlan: {
    title: 'Tafelschikking',
    loading: 'Tafelschikking laden...',
    unsaved: 'Niet opgeslagen',
    saved: 'Plan opgeslagen!',
    save: 'Opslaan',
    unplacedGuests: 'Niet geplaatste gasten',
    allGuestsPlaced: 'Alle gasten zijn geplaatst!',
    addTable: 'Tafel toevoegen',
    addElement: 'Element toevoegen',
    entrance: 'Ingang',
    mainEntrance: 'Hoofdingang',
    stage: 'Podium',
    entranceAdded: 'Ingang toegevoegd',
    stageAdded: 'Podium toegevoegd',
    dimensions: 'Plan afmetingen',
    width: 'Breedte',
    height: 'Hoogte',
    default: 'Standaard',
    large: 'Groot',
    extraLarge: 'Extra groot',
    xxl: 'XXL',
    zoomIn: 'Inzoomen',
    zoomOut: 'Uitzoomen',
    resetView: 'Weergave resetten',
    fullscreen: 'Volledig scherm',
    adjustDimensions: 'Afmetingen aanpassen',
    toggleInitials: 'Initialen tonen/verbergen',
    noTables: 'Nog geen tafels',
    createFirstTable: 'Eerste tafel maken',
    color: 'Kleur',
    shape: 'Vorm',
    size: 'Grootte',
    guests: 'Gasten',
    dragGuestsHere: 'Sleep gasten hierheen',
    deleteTable: 'Tafel verwijderen',
    confirmDeleteTable: 'Tafel "{{name}}" verwijderen?',
    newTable: 'Nieuwe tafel',
    tableName: 'Tafelnaam',
    tableNamePlaceholder: 'Tafel 1, Eretafel...',
    capacity: 'Capaciteit (personen)',
    create: 'Maken'
  },

  // Table Management
  tableManagement: {
    title: 'Tafelbeheer',
    guestList: 'Gastenlijst',
    addTable: 'Tafel toevoegen',
    tables: 'Tafels',
    totalCapacity: 'Totale capaciteit',
    seatedGuests: 'Geplaatste gasten',
    notSeated: 'Niet geplaatst',
    noGuestAssigned: 'Geen gast toegewezen',
    removeFromTable: 'Van tafel verwijderen',
    add: 'Toevoegen',
    noTableCreated: 'Geen tafels aangemaakt',
    createFirstTable: 'Eerste tafel maken',
    unplacedGuests: 'Niet geplaatste gasten',
    place: 'Plaatsen →',
    addTableTitle: 'Tafel toevoegen',
    tableNameLabel: 'Tafelnaam *',
    tableNamePlaceholder: 'Bijv.: Bruidstafel, Tafel 1...',
    capacityLabel: 'Capaciteit (aantal personen)',
    createTable: 'Tafel maken',
    editTableTitle: 'Tafel bewerken',
    addTo: 'Toevoegen aan {{name}}',
    allGuestsSeated: 'Alle gasten zijn al geplaatst',
    confirmDelete: 'Verwijdering bevestigen',
    confirmDeleteMessage: 'Weet u zeker dat u de tafel wilt verwijderen',
    guestsWillBeUnassigned: 'Gasten aan deze tafel worden gemarkeerd als "niet geplaatst".',
    present: 'Aanwezig',
    absent: 'Afwezig',
    markPresent: 'Markeren als aanwezig',
    markAbsent: 'Markeren als afwezig',
    presenceChanged: '{{name}} gemarkeerd als {{status}}',
    presenceError: 'Fout bij het wijzigen van de status',
    presentCount: '{{count}}/{{total}} aanwezig',
    sortLabel: 'Tafels sorteren',
    sortNameAsc: 'Naam (A → Z)',
    sortNameDesc: 'Naam (Z → A)',
    sortCapacityDesc: 'Capaciteit (aflopend)',
    sortCapacityAsc: 'Capaciteit (oplopend)',
    sortOccupancyDesc: 'Bezetting (aflopend)',
    sortOccupancyAsc: 'Bezetting (oplopend)'
  },

  // QR Scanner
  qrScanner: {
    title: 'QR-code Scanner',
    guestList: 'Gastenlijst',
    tables: 'Tafels',
    scanTicket: 'Ticket scannen',
    scanInstructions: 'Richt de camera op de QR-code van het uitnodigingsticket',
    coupleTicket: 'Koppelticket - Selecteer persoon',
    present: 'AANWEZIG',
    absent: 'AFWEZIG',
    name: 'Naam',
    gender: 'Geslacht',
    male: 'Man',
    female: 'Vrouw',
    ticketType: 'Tickettype',
    couple: 'Koppel',
    single: 'Single',
    organizerRelation: 'Relatie met organisator',
    assignedTable: 'Toegewezen tafel',
    coupleStatus: 'Koppelstatus',
    presentStatus: 'Aanwezig',
    absentStatus: 'Afwezig',
    presentFemale: 'Aanwezig',
    absentFemale: 'Afwezig',
    markPresent: 'Markeer aanwezig',
    markAbsent: 'Markeer afwezig',
    scanAnother: 'Ander ticket scannen',
    instructions: 'Instructies',
    instruction1: 'Scan de QR-code op het uitnodigingsticket',
    instruction2: 'Controleer de gastinformatie',
    instruction3: 'Wijzig indien nodig de aanwezigheidsstatus',
    instruction4: 'Bij koppeltickets selecteert u de betreffende persoon',
    instruction5: 'U kunt hetzelfde ticket meerdere keren scannen',
    markedAs: '{{name}} gemarkeerd als {{status}}'
  },

  // Questionnaire Responses
  questionnaireResponses: {
    title: 'Vragenlijst Reacties',
    loading: 'Reacties laden...',
    respondents: 'Respondenten',
    questions: 'Vragen',
    completed: 'Voltooid',
    respondentList: 'Lijst van respondenten',
    noResponses: 'Nog geen reacties',
    shareToReceive: 'Deel uw vragenlijst om reacties te ontvangen',
    anonymous: 'Anoniem',
    noAnswer: 'Geen antwoord',
    answers: 'antwoorden',
    abandoned: 'Afgebroken',
    completedStatus: 'Voltooid',
    inProgress: 'In behandeling',
    responseDetails: 'Antwoorddetails',
    sessionAbandoned: 'Sessie afgebroken',
    noQuestionsAnswered: 'Deze persoon is begonnen met de vragenlijst maar heeft geen vragen beantwoord.',
    viewFullResults: 'Volledige resultatenpagina bekijken',
    deleteResponse: 'Deze reactie verwijderen?',
    deleteResponseMessage: 'De reactie van <strong>{{name}}</strong> wordt permanent verwijderd.',
    responseOf: 'De reactie van'
  },

  // Quiz Responses
  quizResponses: {
    loading: 'Antwoorden laden...',
    title: 'Quiz-antwoorden',
    participants: 'Deelnemers',
    averageScore: 'Gemiddelde score',
    averageSuccessRate: 'Gemiddeld slagingspercentage',
    participantsList: 'Deelnemerslijst',
    noResponses: 'Nog geen antwoorden',
    shareQuiz: 'Deel uw quiz om antwoorden te ontvangen',
    abandoned: 'Afgebroken',
    responseDetails: 'Antwoorddetails',
    answer: 'Antwoord',
    correctAnswer: 'Juiste antwoord',
    sessionAbandoned: 'Sessie afgebroken',
    noQuestionsAnswered: 'Deze persoon is begonnen met de quiz maar heeft geen vragen beantwoord.',
    viewFullResults: 'Volledige resultatenpagina bekijken',
    deleteResponse: 'Deze reactie verwijderen?',
    responseOf: 'De reactie van'
  },

  // Quiz Results
  quizResults: {
    loading: 'Resultaten laden...',
    title: 'Quiz-resultaten',
    totalScore: 'Totale score',
    correct: 'Correct',
    incorrect: 'Onjuist',
    success: 'Succes',
    viewLeaderboard: 'Klassement bekijken',
    responseDetails: 'Antwoorddetails',
    viewAll: 'Alles bekijken',
    revisionMode: 'Herhalingsmodus',
    revisionModeActive: 'Herhalingsmodus actief',
    showingIncorrect: 'Alleen {{count}} onjuiste antwoord(en) weergeven',
    yourAnswer: 'Uw antwoord',
    noAnswer: 'Geen antwoord',
    correctAnswer: 'Juiste antwoord',
    points: 'Punten',
    time: 'Tijd',
    replay: 'Opnieuw spelen',
    home: 'Home'
  },

  // Quiz Leaderboard
  quizLeaderboard: {
    loading: 'Klassement laden...',
    title: 'Klassement',
    share: 'Delen',
    uniquePlayers: 'Unieke spelers',
    gamesPlayed: 'Gespeelde spellen',
    highestScore: 'Hoogste score',
    averageScore: 'Gemiddelde score',
    filterAll: 'Alle',
    filterToday: 'Vandaag',
    filterWeek: '7 dagen',
    filterMonth: '30 dagen',
    noScores: 'Nog geen scores',
    beFirst: 'Wees de eerste om te spelen!',
    playNow: 'Nu spelen',
    points: 'punten',
    joinLeaderboard: 'Speel en doe mee aan het klassement'
  },

  // Join Quiz Live
  joinQuizLive: {
    loading: 'Zoeken naar een actieve sessie...',
    liveSession: 'Live sessie!',
    playersWaiting: '{{count}} speler(s) wachten',
    joinSession: 'Deelnemen aan sessie',
    noSession: 'Geen actieve sessie',
    hostNotStarted: 'De host heeft nog geen sessie gestart',
    hasSessionCode: 'Heeft u een sessiecode?',
    sessionCodePlaceholder: 'Sessiecode...',
    or: 'of',
    playSolo: 'Solo spelen',
    questions: 'vragen',
    perQuestion: 's per vraag'
  },

  // Event Visitors
  eventVisitors: {
    title: 'Geregistreerde bezoekers',
    refresh: 'Vernieuwen',
    totalVisitors: 'Totaal bezoekers',
    pdfDownloaded: 'PDFs gedownload',
    lastVisit: 'Laatste bezoek',
    visitorsList: 'Bezoekerslijst',
    registeredOn: 'Geregistreerd op',
    pdfDownloadedStatus: 'PDF gedownload',
    noPdf: 'Geen PDF',
    generatePdf: 'PDF genereren',
    noVisitors: 'Geen geregistreerde bezoekers',
    visitorsWillAppear: 'Bezoekers verschijnen hier wanneer ze hun naam invoeren',
    deleteVisitor: 'Deze bezoeker verwijderen?',
    deleteVisitorConfirm: 'Wilt u {{name}} echt van de lijst verwijderen?',
    backToDashboard: 'Terug naar dashboard',
    eventNotFound: 'Evenement niet gevonden',
    unauthorized: 'U bent niet gemachtigd om deze pagina te bekijken',
    loadingError: 'Fout bij het laden van gegevens',
    pdfGenerated: 'PDF gegenereerd voor {{name}}',
    pdfError: 'Fout bij het genereren van PDF',
    visitorDeleted: 'Bezoeker verwijderd',
    deleteError: 'Fout bij verwijderen',
    invitation: 'Uitnodiging'
  },

  // Planning (Programs & Menus)
  planning: {
    title: 'Planning',
    subtitle: 'Beheer programma\'s en menu\'s van uw evenement',
    programs: 'Programma\'s',
    menus: 'Menu\'s',
    shareLinks: 'Deellinks',
    createProgram: 'Programma maken',
    editProgram: 'Programma bewerken',
    createMenu: 'Menu maken',
    editMenu: 'Menu bewerken',
    noProgramsYet: 'Geen programma\'s gemaakt',
    noMenusYet: 'Geen menu\'s gemaakt',
    noLinksYet: 'Geen deellinks gegenereerd',
    generateQR: 'QR-code / Link genereren',
    generateQRTitle: 'Deellink genereren',
    generateQRDescription: 'Selecteer de elementen om te delen met uw gasten',
    editQRTitle: 'QR-code bewerken',
    editQRDescription: 'Voeg elementen toe of verwijder ze. De QR-code en link blijven hetzelfde.',
    saveChanges: 'Opslaan',
    linkUpdated: 'QR-code bijgewerkt!',
    generate: 'Genereren',
    downloadQR: 'QR downloaden',
    noContentToShare: 'Geen inhoud om te delen',
    createContentFirst: 'Maak eerst programma\'s of menu\'s',
    includeGuestbook: 'Gastenboek opnemen',
    confirmDeleteProgram: 'Weet u zeker dat u dit programma wilt verwijderen?',
    confirmDeleteMenu: 'Weet u zeker dat u dit menu wilt verwijderen?',
    selectToView: 'Kies wat u wilt bekijken',
    invalidLink: 'Deze deellink is niet meer geldig',
    eventNotFound: 'Evenement niet gevonden',
    noContentAvailable: 'Geen inhoud beschikbaar',
    program: {
      info: 'Programma-informatie',
      title: 'Programmatitel',
      titlePlaceholder: 'Bijv.: Het Dagprogramma',
      titleRequired: 'Titel is vereist',
      date: 'Datum / Periode',
      datePlaceholder: 'Bijv.: Zaterdag 14 juni',
      dateHint: 'Vrije tekst - schrijf zoals u wilt',
      items: 'Activiteiten',
      addItem: 'Activiteit toevoegen',
      addFirstItem: 'Eerste activiteit toevoegen',
      noItems: 'Geen activiteiten in dit programma',
      activityName: 'Activiteitnaam',
      activityNamePlaceholder: 'Bijv.: Gastontvangst',
      description: 'Beschrijving',
      descriptionPlaceholder: 'Beschrijf deze activiteit...',
      bgColor: 'Achtergrondkleur',
      textColor: 'Tekstkleur',
      images: 'Afbeeldingen',
      viewMap: 'Kaart bekijken',
      activities: 'activiteiten'
    },
    menu: {
      info: 'Menu-informatie',
      title: 'Menutitel',
      titlePlaceholder: 'Bijv.: Galadiner Menu',
      titleRequired: 'Titel is vereist',
      starters: 'Voorgerechten',
      mains: 'Hoofdgerechten',
      desserts: 'Desserts',
      dish: 'Gerecht',
      addDish: 'Gerecht toevoegen',
      dishName: 'Gerechtnaam',
      dishNamePlaceholder: 'Bijv.: Huisgemaakte foie gras',
      dishDescription: 'Gerechtbeschrijving',
      dishDescriptionPlaceholder: 'Beschrijf dit gerecht...',
      dishImage: 'Gerechtafbeelding'
    },
    editor: {
      bold: 'Vet',
      italic: 'Cursief',
      textColor: 'Tekstkleur',
      mapLinkPlaceholder: 'Google Maps-link...'
    }
  },

  // Image Upload
  imageUpload: {
    import: 'Importeren',
    urlPlaceholder: 'https://voorbeeld.com/afbeelding.jpg',
    uploadInProgress: 'Upload bezig...',
    imageUploaded: 'Afbeelding geüpload',
    deleteImage: 'Afbeelding verwijderen',
    clickToSelect: 'Klik om een afbeelding te selecteren',
    maxSize: 'PNG, JPG, GIF tot 5 MB',
    preview: 'Voorbeeld',
    selectImage: 'Selecteer een afbeelding',
    maxSizeError: 'Afbeelding mag niet groter zijn dan 60 MB',
    maxSizeErrorWithSize: 'Afbeelding mag niet groter zijn dan {{size}} MB',
    storageNotConfigured: 'Firebase Storage is niet geconfigureerd. Schakel Storage in de Firebase-console in.'
  },

  // Tasks
  tasks: {
    title: 'Taken',
    add: 'Taak toevoegen',
    addFirst: 'Mijn eerste taak toevoegen',
    selectTask: 'Kies een taak',
    selectTaskDescription: 'Selecteer een voorgedefinieerde taak of maak een eigen taak',
    createCustom: 'Eigen taak maken',
    predefined: 'Voorgedefinieerde bruiloftstaken',
    newTask: 'Nieuwe taak',
    editTask: 'Taak bewerken',
    taskName: 'Taaknaam',
    taskNamePlaceholder: 'Bijv.: Fotograaf boeken',
    description: 'Beschrijving',
    descriptionPlaceholder: 'Beschrijf de details van deze taak...',
    deadline: 'Deadline',
    cost: 'Geschatte kosten',
    responsibles: 'Verantwoordelijken',
    responsibleName: 'Naam',
    responsibleContact: 'Telefoon / E-mail',
    addResponsible: 'Verantwoordelijke toevoegen',
    location: 'Locatie',
    locationNamePlaceholder: 'Locatienaam (bijv.: Fotostudio Martin)',
    locationUrlPlaceholder: 'Google Maps-link of routebeschrijving',
    directions: 'Routebeschrijving',
    reminder: 'Herinnering',
    reminderOn: 'Herinnering actief',
    setReminder: 'Herinnering instellen',
    configure: 'Configureren',
    venue: 'Locatie/Zaal',
    quantity: 'Aantal',
    notes: 'Notities',
    notesPlaceholder: 'Extra notities...',
    responses: 'Voortgangsupdates',
    addResponse: 'Update toevoegen...',
    confirmDelete: 'Weet je zeker dat je deze taak wilt verwijderen?',
    all: 'Alle',
    pending: 'In afwachting',
    completed: 'Voltooid',
    overdue: 'Verlopen',
    search: 'Taken zoeken...',
    empty: 'Geen taken',
    emptyDescription: 'Begin met het plannen van je evenement door taken toe te voegen',
    markComplete: 'Markeer als voltooid',
    markIncomplete: 'Markeer als niet voltooid',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    daysLeft: '{{days}} dagen over'
  },

  // Notifications
  notifications: {
    title: 'Meldingen',
    empty: 'Geen meldingen',
    emptyDescription: 'Je ontvangt hier taakherinneringen',
    markAllRead: 'Alles als gelezen markeren',
    markRead: 'Als gelezen markeren',
    viewAll: 'Alle meldingen bekijken',
    new: 'Nieuw',
    justNow: 'Zojuist',
    minutesAgo: '{{count}} min geleden',
    hoursAgo: '{{count}} uur geleden',
    daysAgo: '{{count}} dagen geleden',
    today: 'Vandaag',
    yesterday: 'Gisteren',
    all: 'Alle',
    unread: 'Ongelezen',
    read: 'Gelezen',
    unreadCount: '{{count}} ongelezen',
    allRead: 'Alle meldingen gelezen',
    noUnread: 'Geen ongelezen meldingen',
    noRead: 'Geen gelezen meldingen',
    chatEscalation: '💬 Nieuwe chat wacht',
    chatEscalationMessage: '{{userName}} vraagt om menselijke hulp',
    goToChat: 'Chat bekijken'
  },

  // Questionnaire Results
  questionnaireResults: {
    loading: 'Resultaten laden...',
    title: 'Uw antwoorden',
    completedOn: 'Vragenlijst ingevuld op',
    unknownDate: 'Onbekende datum',
    answersRecorded: 'antwoorden geregistreerd',
    responseDetails: 'Antwoorddetails',
    noAnswer: 'Geen antwoord',
    noAnswersRecorded: 'Geen antwoorden geregistreerd',
    backToHome: 'Terug naar home'
  },

  // Admin Quiz Music
  adminQuizMusic: {
    loading: 'Muziek laden...',
    title: 'Quiz Muziekbeheer',
    subtitle: 'Beheer lobbymuziek, geluidseffecten en gameplay-muziek',
    backToAdmin: 'Terug naar admin panel',
    lobbyTab: 'Lobby',
    effectsTab: 'Effecten',
    gameplayTab: 'Gameplay',
    lobbyMusic: 'Lobby Muziek',
    lobbyMusicDesc: 'Deze muziek wordt willekeurig afgespeeld in de wachtkamer.',
    soundEffects: 'Geluidseffecten',
    soundEffectsDesc: 'Deze geluiden worden op specifieke momenten in de quiz afgespeeld.',
    gameplayMusic: 'Gameplay Muziek',
    gameplayMusicDesc: 'Elke vraagduur heeft zijn eigen muziekbank.',
    questionDuration: '{{duration}}s vraag → ~{{musicDuration}}s muziek',
    lobbyMusicTitle: '🎵 Lobby Muziek',
    lobbyMusicSubtitle: 'Speelt willekeurig in de wachtkamer',
    countdownTitle: '⏱️ Aftellen (3-2-1)',
    countdownSubtitle: 'Geluid voor het spel begint',
    transitionTitle: '🔄 Vraag Overgang',
    transitionSubtitle: 'Kort geluid tussen vragen',
    resultsTitle: '📊 Resultaten / Statistieken',
    resultsSubtitle: 'Muziek tijdens resultatenweergave',
    podiumTitle: '🏆 Eindpodium',
    podiumSubtitle: 'Feestelijke muziek voor het podium',
    questionsTitle: '🎮 {{duration}}s Vragen',
    questionsSubtitle: 'Muziek voor {{duration}} seconden vragen',
    uploading: 'Uploaden...',
    addAudio: 'Klik om audiobestanden toe te voegen',
    noMusic: 'Geen muziek',
    unknownError: 'Onbekende fout'
  },

  services: {
    marketplaceTitle: 'Vind de juiste professional',
    marketplaceSubtitle: 'Betrouwbare professionals voor al uw behoeften en projecten.',
    searchPlaceholder: 'Zoek een service of bedrijf...',
    noServices: 'Nog geen services',
    noServicesDesc: 'Wees de eerste die zijn service in deze categorie aanbiedt.',
    proposeService: 'Een service aanbieden',
    onQuote: 'Op aanvraag',
    views: 'weergaven',
    window: 'Tabblad',
    notFound: 'Service niet gevonden',
    notYours: 'Deze service is niet van u',
    updated: 'Service bijgewerkt!',
    submitted: 'Service ingediend! Hij wordt na controle gepubliceerd.',
    createService: 'Een service maken',
    editTitle: 'Service bewerken',
    createSubtitle: 'Presenteer uw activiteit duidelijk en aantrekkelijk.',
    autoTranslateHint: 'Uw teksten worden bij publicatie automatisch vertaald naar de andere talen (Frans, Engels, Duits).',
    generalInfo: 'Algemene informatie',
    businessName: 'Bedrijfsnaam',
    serviceTitle: 'Servicetitel',
    titlePlaceholder: 'Bijv. Professionele fotograaf & videograaf',
    tagline: 'Slogan',
    taglinePlaceholder: 'Een korte zin die uw aanbod samenvat',
    category: 'Categorie',
    serviceType: 'Servicetype',
    country: 'Land',
    city: 'Stad',
    cityPlaceholder: 'Kies of typ uw stad',
    coverImage: 'Omslagafbeelding',
    profilePhoto: 'Profielfoto',
    profilePhotoHint: 'Als u geen foto toevoegt, worden de initialen van uw naam weergegeven.',
    price: 'Prijs (optioneel)',
    pricePlaceholder: 'Bijv. Vanaf €350 / Op aanvraag',
    priceComment: 'Opmerking over de prijs',
    priceCommentPlaceholder: 'Bijv. voor een dienst van 2 uur',
    contactInfo: 'Contactgegevens',
    contactInfoDesc: 'Kies welke gegevens zichtbaar zijn voor bezoekers. Een contactformulier wordt altijd getoond.',
    email: 'E-mail',
    showEmail: 'Mijn e-mail openbaar tonen',
    phone: 'Telefoon',
    showPhone: 'Mijn nummer openbaar tonen',
    windows: 'Vensters / Tabbladen',
    addWindow: 'Tabblad toevoegen',
    windowTitle: 'Titel van het tabblad (bijv. Bruiloft)',
    imageBlock: 'Afbeelding',
    textBlock: 'Tekst',
    textPlaceholder: 'Schrijf uw paragraaf...',
    captionPlaceholder: 'Bijschrift van de afbeelding (optioneel)',
    noBlocks: 'Voeg tekst of afbeeldingen toe aan dit tabblad.',
    addText: 'Tekst toevoegen',
    addImage: 'Afbeelding toevoegen',
    verifyFirst: 'Verifieer eerst uw identiteit',
    verifyFirstDesc: 'Om een service te publiceren, moet u eerst uw identiteit laten verifiëren. Dit is een eenmalige, veilige stap.',
    startVerification: 'Verificatie starten',
    notAvailable: 'Service niet beschikbaar',
    notAvailableDesc: 'Deze service bestaat niet of is nog niet gepubliceerd.',
    backToMarketplace: 'Alle services',
    previewPending: 'Voorbeeld — deze service wacht op goedkeuring door een beheerder.',
    previewRejected: 'Deze service is afgewezen.',
    previewRestricted: 'De weergave van deze service is beperkt door een beheerder.',
    emptyWindow: 'Geen inhoud in dit tabblad.',
    errors: {
      businessName: 'Voer de bedrijfsnaam in.',
      title: 'Voer een titel in voor uw service.',
      type: 'Kies een servicetype.',
      country: 'Kies uw land.',
      city: 'Voer uw stad in.',
      email: 'Voer een contact-e-mail in.'
    },
    status: {
      pending: 'Wacht op controle',
      approved: 'Gepubliceerd',
      rejected: 'Afgewezen',
      restricted: 'Beperkt'
    },
    categories: {
      evenement: 'Evenementen', maison: 'Huis & Klussen', beaute: 'Schoonheid & Welzijn', formation: 'Lessen & Opleiding', digital: 'IT & Digitaal', mode: 'Mode & Naaien', transport: 'Transport & Levering', autre: 'Andere services'
    },
    types: {
      photographe: 'Fotograaf', videaste: 'Videograaf', 'event-planner': 'Eventplanner', dj: 'DJ', traiteur: 'Catering', decoration: 'Decoratie', animation: 'Animatie', 'location-salle': 'Zaalverhuur', fleuriste: 'Bloemist', musicien: 'Muzikant', mc: 'Ceremoniemeester', securite: 'Beveiliging', plombier: 'Loodgieter', electricien: 'Elektricien', menuisier: 'Timmerman', peintre: 'Schilder', jardinier: 'Tuinman', demenagement: 'Verhuizing', nettoyage: 'Schoonmaak', bricolage: 'Klusjesman', coiffeur: 'Kapper', maquilleur: 'Visagist', estheticienne: 'Schoonheidsspecialiste', manucure: 'Manicure', massage: 'Massage', 'coach-sportif': 'Sportcoach', 'cours-particuliers': 'Privelessen', langues: 'Talen', musique: 'Muziek', 'soutien-scolaire': 'Bijles', coaching: 'Coaching', developpeur: 'Ontwikkelaar', graphiste: 'Grafisch ontwerper', webdesign: 'Webdesign', marketing: 'Marketing', redaction: 'Tekstschrijven', 'community-manager': 'Communitymanager', couture: 'Naaien', stylisme: 'Styling', retouche: 'Vermaken', creation: 'Creatie', chauffeur: 'Chauffeur', livraison: 'Levering', vtc: 'Privévervoer', demenageur: 'Verhuizer', autre: 'Anders'
    },
    idDocuments: {
      'carte-identite': 'Identiteitskaart', 'passeport-ue': 'Paspoort (Europese Unie)', 'carte-sejour': 'Verblijfsvergunning', visa: 'Visum', 'permis-conduire': 'Rijbewijs'
    },
    marketplace: {
      navLink: 'Services',
      homeTitle: 'Vind de ideale professional',
      homeSubtitle: 'Fotografen, dj\'s, cateraars, eventplanners en meer — geverifieerde professionals voor al uw projecten.',
      browseAll: 'Services bekijken',
      becomeProvider: 'Mijn services aanbieden'
    },
    verify: {
      title: 'Identiteitsverificatie',
      subtitle: 'Een eenmalige stap om een betrouwbare aanbieder te worden.',
      approvedTitle: 'Identiteit geverifieerd ✅',
      approvedDesc: 'U kunt nu uw services maken en publiceren.',
      pendingTitle: 'Verificatie loopt',
      pendingDesc: 'Ons team beoordeelt uw verzoek. U wordt per e-mail en in uw meldingen op de hoogte gebracht zodra het is verwerkt.',
      rejectedTitle: 'Vorig verzoek afgewezen',
      resubmit: 'U kunt hieronder nieuwe documenten indienen.',
      explain: 'Om het platform veilig te houden, verifiëren we de identiteit van elke aanbieder. Lever een geldig identiteitsbewijs en neem een korte video van uzelf op zodat ons team kan bevestigen dat de identiteit bij u hoort. Deze documenten zijn vertrouwelijk en worden alleen voor verificatiedoeleinden gebruikt.',
      idType: 'Type identiteitsbewijs',
      idDocument: 'Identiteitsbewijs (afbeelding of PDF)',
      uploadFile: 'Uploaden (afbeelding / PDF)',
      scanFile: 'Scannen met camera',
      selfieVideo: 'Live selfievideo',
      selfieHint: 'Film uzelf een paar seconden van voren. Met deze video kunnen we uw gezicht vergelijken met uw identiteitsbewijs.',
      consent: 'Ik ga ermee akkoord dat mijn identiteitsbewijs en video door HugoQuiz worden verwerkt voor identiteitsverificatie, in overeenstemming met de gebruiksvoorwaarden en het privacybeleid.',
      submit: 'Mijn verificatieverzoek indienen',
      submitted: 'Uw verzoek is naar ons team verzonden.',
      invalidIdFile: 'Lever een afbeelding of een PDF.',
      fileTooLarge: 'Bestand te groot (max. 30 MB).',
      needId: 'Lever uw identiteitsbewijs.',
      needSelfie: 'Neem uw selfievideo op.',
      needConsent: 'U moet de voorwaarden accepteren.',
      cameraError: 'Geen toegang tot de camera. Sta toegang toe en probeer het opnieuw.',
      enableCamera: 'Camera inschakelen',
      recorded: 'Video opgenomen',
      startRecording: 'Starten',
      stopRecording: 'Stoppen',
      retake: 'Opnieuw'
    },
    contact: {
      title: 'Contact',
      intro: 'Beschrijf uw behoefte of project nauwkeurig en wij reageren zo snel mogelijk.',
      fullName: 'Volledige naam',
      phone: 'Telefoonnummer',
      email: 'E-mailadres',
      emailPlaceholder: 'jij@voorbeeld.com',
      invalidEmail: 'Voer een geldig e-mailadres in.',
      clientType: 'Type klant',
      individual: 'Particulier',
      company: 'Bedrijf',
      subject: 'Onderwerp van de aanvraag',
      request: 'Beschrijf uw aanvraag / de gewenste service',
      send: 'Mijn aanvraag verzenden',
      sent: 'Uw aanvraag is verzonden!',
      sentTitle: 'Aanvraag verzonden!',
      sentDesc: 'De aanbieder heeft uw bericht ontvangen en reageert spoedig.',
      fillRequired: 'Vul de verplichte velden in.',
      consentRequired: 'U moet de verwerking van uw gegevens accepteren.',
      consent: 'Ik ga ermee akkoord dat mijn gegevens worden gedeeld met de aanbieder zodat hij op mijn aanvraag kan reageren.'
    },
    reviews: {
      title: 'Beoordelingen',
      rating: 'beoordeling',
      ratings: 'beoordelingen',
      customerReviews: 'Klantbeoordelingen',
      summaryDesc: 'Deel uw ervaring met deze aanbieder om andere klanten te helpen.',
      writeReview: 'Beoordeling schrijven',
      yourReview: 'Uw beoordeling',
      yourRating: 'Uw beoordeling',
      yourName: 'Uw naam',
      yourComment: 'Uw opmerking',
      optional: 'optioneel',
      commentPlaceholder: 'Beschrijf uw ervaring…',
      commentModerated: 'Opmerkingen worden door een beheerder gecontroleerd voordat ze worden gepubliceerd.',
      submit: 'Mijn beoordeling plaatsen',
      submitted: 'Bedankt voor uw beoordeling!',
      submittedPending: 'Bedankt! Uw opmerking wordt na controle gepubliceerd.',
      pendingNote: 'Uw opmerking wacht op goedkeuring door een beheerder.',
      alreadyReviewed: 'U heeft deze service al beoordeeld.',
      noReviews: 'Nog geen beoordelingen. Wees de eerste!',
      anonymous: 'Anoniem',
      pickRating: 'Geef een beoordeling.',
      enterName: 'Voer uw naam in.'
    },
    messages: {
      title: 'Ontvangen berichten',
      subtitle: 'Aanvragen die via uw services worden verzonden, verschijnen hier.',
      empty: 'Nog geen berichten'
    }
  }
}
